export const accountGroup = [
  { label: "Domestic Vendor", value: "YB01", description: "Domestic Vendor" },
  { label: "Service Vendor", value: "YB02", description: "Service Vendor" },
  { label: "Employee Vendor", value: "YB04", description: "Employee Vendor" },
  // { label: "my desc", value: "YB07", description: "my desc" },
  {
    label: "Domestic Capital Goods",
    value: "YB12",
    description: "Domestic Capital Goods",
  },
  {
    label: "Import Capital Goods",
    value: "YB13",
    description: "Import Capital Goods",
  },
  { label: "Forwarding Agent", value: "YB19", description: "Forwarding Agent" },
];

export const reconcillationAccount = [
  {
    label: "Creditor (RM Import)",
    value: "14110010",
    description: "Creditor (RM Import)",
  },
  {
    label: "Creditor (RM Domestic)",
    value: "14110020",
    description: "Creditor (RM Domestic)",
  },
  {
    label: "Creditor (PM Domestic)",
    value: "14110030",
    description: "Creditor (PM Domestic)",
  },
  {
    label: "Creditor (PM Import)",
    value: "14110040",
    description: "Creditor (PM Import)",
  },
  {
    label: "Creditor (Capital Domestic)",
    value: "14110050",
    description: "Creditor (Capital Domestic)",
  },
  {
    label: "Creditor (Capital Import)",
    value: "14110060",
    description: "Creditor (Capital Import)",
  },
  {
    label: "Creditor (Other Material Import)",
    value: "14110070",
    description: "Creditor (Other Material Import)",
  },
  {
    label: "Creditor (Other Material Domestic)",
    value: "14110080",
    description: "Creditor (Other Material Domestic)",
  },
  {
    label: "Creditor (Traded Goods)",
    value: "14110090",
    description: "Creditor (Traded Goods)",
  },
  {
    label: "Creditor (Employee)",
    value: "14110100",
    description: "Creditor (Employee)",
  },
  {
    label: "Creditor (Service)",
    value: "14110110",
    description: "Creditor (Service)",
  },
  {
    label: "Creditors (Statutory)",
    value: "14110120",
    description: "Creditors (Statutory)",
  },
  {
    label: "Creditors - Loans",
    value: "14110140",
    description: "Creditors - Loans",
  },
  {
    label: "Creditors - Sale Return",
    value: "14110150",
    description: "Creditors - Sale Return",
  },
  {
    label: "Creditors - Service Import",
    value: "14110160",
    description: "Creditors - Service Import",
  },
];

export const reconAccountMumbai = [
  {
    label: "Creditors - RM Domestic",
    value: "14110010",
    description: "Creditors - RM Domestic",
  },
  {
    label: "Creditors - RM Imports",
    value: "14110020",
    description: "Creditors - RM Imports",
  },
  {
    label: "Creditors - PM Domestic",
    value: "14110030",
    description: "Creditors - PM Domestic",
  },
  {
    label: "Creditors - PM Imports",
    value: "14110040",
    description: "Creditors - PM Imports",
  },
  {
    label: "Creditors - Finished Goods",
    value: "14110070",
    description: "Creditors - Finished Goods",
  },
  {
    label: "Creditors - Capital Goods Domestic",
    value: "14110090",
    description: "Creditors - Capital Goods Domestic",
  },
  {
    label: "Creditors - Capital Goods Import",
    value: "14110100",
    description: "Creditors - Capital Goods Import",
  },
  {
    label: "Creditors - Other material Domestic",
    value: "14110110",
    description: "Creditors - Other material Domestic",
  },
  {
    label: "Creditors - Other material Import",
    value: "14110120",
    description: "Creditors - Other material Import",
  },
  {
    label: "Creditors - Employee",
    value: "14110140",
    description: "Creditors - Employee",
  },
  {
    label: "Creditors - Service Domestic",
    value: "14110150",
    description: "Creditors - Service Domestic",
  },
  {
    label: "Creditors - Statutory",
    value: "14110160",
    description: "Creditors - Statutory",
  },
  {
    label: "Creditors - Loan",
    value: "14110170",
    description: "Creditors - Loan",
  },
  {
    label: "Creditors - Foreign Remittances",
    value: "14110180",
    description: "Creditors - Foreign Remittances",
  },
  {
    label: "Creditors - Sale Return",
    value: "14110190",
    description: "Creditors - Sale Return",
  },
  {
    label: "Creditors - Service Foreign",
    value: "14110200",
    description: "Creditors - Service Foreign",
  },
  {
    label: "Creditors - Loan for Employees",
    value: "14110210",
    description: "Creditors - Loan for Employees",
  },
];

export const taxHolding = [
  { label: "India", value: "IN", description: "India" },
];

export const whTypeInvoice = [
  {
    label: "194A-INV-Interest other than Int on Secu",
    value: "A0",
    description: "194A-INV-Interest other than Int on Secu",
  },
  {
    label: "194A-INV-Interest-Security-company etc",
    value: "AA",
    description: "194A-INV-Interest-Security-company etc",
  },
  {
    label: "194C-INV-Contra & AdvContractor(Ind&HUF)",
    value: "C0",
    description: "194C-INV-Contra & AdvContractor(Ind&HUF)",
  },
  {
    label: "194C-INV-Contractor & adv cont(Firm&Com)",
    value: "CA",
    description: "194C-INV-Contractor & adv cont(Firm&Com)",
  },
  {
    label: "194D-INV-Insurance commission",
    value: "D0",
    description: "194D-INV-Insurance commission",
  },
  {
    label: "195 - INV - Non Resident(Tech.Fees)-10 %",
    value: "EO",
    description: "195 - INV - Non Resident(Tech.Fees)-10 %",
  },
  {
    label: "194H-INV-Commission brokerage",
    value: "H0",
    description: "194H-INV-Commission brokerage",
  },
  {
    label: "194I-INV- Land & Building",
    value: "I0",
    description: "194I-INV- Land & Building",
  },
  {
    label: "194I-INV-Rent of plant, machinery or equipment",
    value: "IA",
    description: "194I-INV-Rent of plant, machinery or equipment",
  },
  {
    label: "194-IA -INV-TDS on Immovable property",
    value: "IB",
    description: "194-IA -INV-TDS on Immovable property",
  },
  {
    label: "194J-INV-Fees for professional services",
    value: "J0",
    description: "194J-INV-Fees for professional services",
  },
  {
    label: "194J-INV-Fees for Technical services",
    value: "J2",
    description: "194J-INV-Fees for Technical services",
  },
  {
    label: "195 - INV - Non Resident of India -10.3%",
    value: "KI",
    description: "195 - INV - Non Resident of India -10.3%",
  },
  {
    label: "194R: INV-TDS on benefits or perquisites",
    value: "R1",
    description: "194R: INV-TDS on benefits or perquisites",
  },
];

export const whTypeInvoiceBase = [
  {
    label: "194Q: TDS on Purchase of Goods(Non-PAN)",
    value: "4N",
    description: "194Q: TDS on Purchase of Goods(Non-PAN)",
  },
  {
    label: "194Q: INV-TDS on Purchase of Goods",
    value: "4Q",
    description: "194Q: INV-TDS on Purchase of Goods",
  },
];

export const WHTypePayment = [
  {
    label: "194A-PAY-Interest other than Int on Secu",
    value: "A5",
    description: "194A-PAY-Interest other than Int on Secu",
  },
  {
    label: "194A-PAY-Interest-Security-company etc",
    value: "AF",
    description: "194A-PAY-Interest-Security-company etc",
  },
  {
    label: "194C-PAY-Contra & AdvContractor(Ind&HUF)",
    value: "C5",
    description: "194C-PAY-Contra & AdvContractor(Ind&HUF)",
  },
  {
    label: "194C-PAY-Contractor & adv cont(Firm&Com)",
    value: "CF",
    description: "194C-PAY-Contractor & adv cont(Firm&Com)",
  },
  {
    label: "194D-PAY-Insurance commission",
    value: "D5",
    description: "194D-PAY-Insurance commission",
  },
  {
    label: "195-PAY-Non resident of India -10%",
    value: "EP",
    description: "195-PAY-Non resident of India -10%",
  },
  {
    label: "194H-PAY-Commission brokerage",
    value: "H5",
    description: "194H-PAY-Commission brokerage",
  },
  {
    label: "194I-PAY-Rent-Land & Building",
    value: "I5",
    description: "194I-PAY-Rent-Land & Building",
  },
  {
    label: "194-IA-PAY-TDS on Immovable Property",
    value: "IC",
    description: "194-IA-PAY-TDS on Immovable Property",
  },
  {
    label: "194I-PAY-Rent-plant, machinery or equipment",
    value: "IF",
    description: "194I-PAY-Rent-plant, machinery or equipment",
  },
  {
    label: "194J-PAY-Fees for professional services",
    value: "J5",
    description: "194J-PAY-Fees for professional services",
  },
  {
    label: "194J-PAY-Fees for Technical services",
    value: "J7",
    description: "194J-PAY-Fees for Technical services",
  },
  {
    label: "195-PAY-Non resident of India -10.3%",
    value: "KP",
    description: "195-PAY-Non resident of India -10.3%",
  },
  {
    label: "194R-PAY-TDS on benefits or perquisites",
    value: "R2",
    description: "194R-PAY-TDS on benefits or perquisites",
  },
];

export const WHTypePaymentBase = [
  {
    label: "194Q:TDS on Pur. of goods (Non-PAN, PAY)",
    value: "5N",
    description: "194Q:TDS on Pur. of goods (Non-PAN, PAY)",
  },
  {
    label: "194Q:TDS on Purchase of goods (Payment)",
    value: "5Q",
    description: "194Q:TDS on Purchase of goods (Payment)",
  },
];

export const vendorSchema = [
  { label: "DOMESTIC VENDORS", value: "ZD", description: "DOMESTIC VENDORS" },
];

// export const locations = [
//   { label: "Delhi", value: "HO", description: "HO" },
//   { label: "Haridwar", value: "PL", description: "PL" },
//   { label: "ALS-Derabassi", value: "AP", description: "AP" },
//   { label: "Mumbai", value: "UNO-Mumbai", description: "MU" },
// ];

export const locations = [
  { label: "Delhi", value: "HO", description: "HO" },
  { label: "Haridwar", value: "PL", description: "PL" },
  { label: "ALS-Derabassi", value: "AP", description: "AP" },
  { label: "Mumbai", value: "MU", description: "MU" },
];

// export const locations = [
//   { label: "Delhi - HO", value: "HO", description: "Delhi - HO" },
//   { label: "Haridwar - plant", value: "PL", description: "Haridwar - plant" },
//   { label: "API-Derabassi", value: "MU", description: "API-Derabassi" },
//   { label: "UNO-Mumbai", value: "PI", description: "UNO-Mumbai" },
// ];

export const dueDates = [
  { label: "GRN Date", value: "1", description: "GRN Date" },
  { label: "Invoice Date", value: "2", description: "Invoice Date" },
  { label: "Posting Date", value: "3", description: "Posting Date" },
];

export const PurchaseOrg = [
  { Porg: 1000, Description: "Akums-Domestic Procurement", CompanyCode: 1000 },
  // { Porg: 2000, Description: "Akums-Import procurement", CompanyCode: 1000 },
  { Porg: 1601, Description: "AHL-Domestic Procurement", CompanyCode: 1600 },
  // { Porg: 1602, Description: "AHIL-Import procurement", CompanyCode: 1600 },
  {
    Porg: 4001,
    Description: "Qualymed-Domestic Procurement",
    CompanyCode: 4000,
  },
  // { Porg: 4002, Description: "Qualymed-Import procurement", CompanyCode: 4000 },
  {
    Porg: 9000,
    Description: "Maxcure-Domestic Procurement",
    CompanyCode: 9000,
  },
  // { Porg: 9100, Description: "Maxcure-Import Procurement", CompanyCode: 9000 },
  { Porg: 9401, Description: "Malik-Domestic Procurement", CompanyCode: 9400 },
  // { Porg: 9402, Description: "Malik-Import procurement", CompanyCode: 9400 },
  { Porg: 9701, Description: "P&C-Domestic Procurement", CompanyCode: 9700 },
  // { Porg: 9702, Description: "P&C-Import procurement", CompanyCode: 9700 },
  {
    Porg: 9706,
    Description: "P&C-Derabassi-Domestic Procurement",
    CompanyCode: 9700,
  },
  // {
  //   Porg: 9707,
  //   Description: "P&C-Derabassi-Import Procurement",
  //   CompanyCode: 9700,
  // },
  { Porg: 9801, Description: "UNO-Domestic Procurement", CompanyCode: 9800 },
  { Porg: 9901, Description: "Upadhrish Reserchem LLP", CompanyCode: 9900 },
];

export const TransRoute = [
  { label: "ABOH", value: "ABOH", description: "ABOHAR" },
  { label: "ADIL", value: "ADIL", description: "ADILABAD" },
  { label: "AGA", value: "AGA", description: "AGAR" },
  { label: "AGAT", value: "AGAT", description: "AGARTALA" },
  { label: "AGR", value: "AGR", description: "AGRA" },
  { label: "AHM", value: "AHM", description: "AHMEDABAD" },
  { label: "AJM", value: "AJM", description: "AJMER" },
  { label: "AKB", value: "AKB", description: "AKABARPUR" },
  { label: "AKN", value: "AKN", description: "ASHOKNAGAR" },
  { label: "AKO", value: "AKO", description: "AKOLA" },
  { label: "ALAL", value: "ALAL", description: "ASALALI" },
  { label: "ALI", value: "ALI", description: "ALIGARH" },
  { label: "ALLA", value: "ALLA", description: "ALLAHABAD" },
  { label: "ALM", value: "ALM", description: "ALMORA" },
  { label: "ALPP", value: "ALPP", description: "ALAPPUZHA" },
  { label: "ALW", value: "ALW", description: "ALWAR" },
  { label: "AMB", value: "AMB", description: "AMBALA" },
  { label: "AMBE", value: "AMBE", description: "AMBEDKAR NAGAR" },
  { label: "AMBI", value: "AMBI", description: "AMBIKAPUR" },
  { label: "AMBN", value: "AMBN", description: "AMBERNATH" },
  { label: "AMBP", value: "AMBP", description: "AMBERPET(HYD)" },
  { label: "AMD", value: "AMD", description: "AMBAWAD" },
  { label: "AMG", value: "AMG", description: "AMBAJI (GUJRAJ)" },
  { label: "AMI", value: "AMI", description: "AMIPURA" },
  { label: "AMMA", value: "AMMA", description: "Ammapettai" },
  { label: "AMN", value: "AMN", description: "AHMEDNAGAR" },
  { label: "AMO", value: "AMO", description: "AMROHA" },
  { label: "AMRL", value: "AMRL", description: "AMRELI" },
  { label: "AMT", value: "AMT", description: "AMRITSAR" },
  { label: "AMTH", value: "AMTH", description: "AMETHI (C S M NAGAR)" },
  { label: "AMV", value: "AMV", description: "AMRAVATI" },
  { label: "ANA", value: "ANA", description: "ANAND" },
  { label: "ANAN", value: "ANAN", description: "ANANTAPUR" },
  { label: "AND", value: "AND", description: "ANDHERI" },
  { label: "ANG", value: "ANG", description: "ANGUL" },
  { label: "ANGL", value: "ANGL", description: "WEST KARBI ANGLONG" },
  { label: "ANKL", value: "ANKL", description: "ANKLESHWAR" },
  { label: "Anko", value: "Anko", description: "Ankola" },
  { label: "ANNA", value: "ANNA", description: "ANNA NAGAR" },
  { label: "ANNU", value: "ANNU", description: "ANNUPUR" },
  { label: "ANPR", value: "ANPR", description: "ANUPPUR" },
  { label: "AP", value: "AP", description: "ANDHRA PRADESH" },
  { label: "ARGB", value: "ARGB", description: "AURANGABAD" },
  { label: "ARGE", value: "ARGE", description: "ARGENTINA" },
  { label: "ARJ", value: "ARJ", description: "ALIRAJPUR" },
  { label: "ARW", value: "ARW", description: "Arwal" },
  { label: "ARY", value: "ARY", description: "AURIYA" },
  { label: "ASAN", value: "ASAN", description: "ASANSOL" },
  { label: "ASLA", value: "ASLA", description: "ASLA (AHMEDABAD-RURAL)" },
  { label: "ASN", value: "ASN", description: "AJIT SINGH NAGAR" },
  { label: "ASS", value: "ASS", description: "ASSAM" },
  { label: "ASSA", value: "ASSA", description: "ASSAM" },
  { label: "ATHA", value: "ATHA", description: "ATHAL" },
  { label: "AURA", value: "AURA", description: "AURAIYA" },
  { label: "AWY", value: "AWY", description: "ALWAYE(KERALA)" },
  { label: "AYOD", value: "AYOD", description: "AYODHYA" },
  { label: "AZAM", value: "AZAM", description: "AZAMGARH" },
  { label: "BADA", value: "BADA", description: "BADAUN" },
  { label: "BADD", value: "BADD", description: "BADDI" },
  { label: "BADL", value: "BADL", description: "BADLI" },
  { label: "BADR", value: "BADR", description: "Badri Nath Ashram" },
  { label: "BADW", value: "BADW", description: "BADWANI" },
  { label: "BAGA", value: "BAGA", description: "BAGALKOT" },
  { label: "BAGH", value: "BAGH", description: "BAGHPAT" },
  { label: "BAGP", value: "BAGP", description: "BAGPAT" },
  { label: "BAHA", value: "BAHA", description: "BAHALGARH" },
  { label: "BAHR", value: "BAHR", description: "BAHRAICH" },
  { label: "BALA", value: "BALA", description: "BALAGHAT" },
  { label: "BALE", value: "BALE", description: "BALESHWAR" },
  { label: "BALG", value: "BALG", description: "BALLABGARH" },
  { label: "BALL", value: "BALL", description: "BALLIA" },
  { label: "BALR", value: "BALR", description: "BALRAMPUR" },
  { label: "BANA", value: "BANA", description: "BANASKANTHA" },
  { label: "BAND", value: "BAND", description: "BANDRA" },
  { label: "BANG", value: "BANG", description: "BANGLADESH" },
  { label: "BANK", value: "BANK", description: "BANKURA" },
  { label: "BANS", value: "BANS", description: "BANSWARA" },
  { label: "Bara", value: "Bara", description: "Bara" },
  { label: "BARD", value: "BARD", description: "BARDHAMAN" },
  { label: "BARE", value: "BARE", description: "BAREILLY" },
  { label: "BARH", value: "BARH", description: "BARHI" },
  { label: "BARM", value: "BARM", description: "BARMER" },
  { label: "BARN", value: "BARN", description: "BARNALA" },
  { label: "BARO", value: "BARO", description: "BARODA" },
  { label: "BARP", value: "BARP", description: "BARPETA" },
  { label: "BART", value: "BART", description: "Baraut" },
  { label: "BAST", value: "BAST", description: "BASTI" },
  { label: "BATH", value: "BATH", description: "BATHINDA" },
  { label: "BAZP", value: "BAZP", description: "BAZPUR" },
  { label: "BDRG", value: "BDRG", description: "BAHADURGARH" },
  { label: "BEED", value: "BEED", description: "BEED" },
  { label: "BEGU", value: "BEGU", description: "BEGUSARAI" },
  { label: "BEHA", value: "BEHA", description: "BEHAR" },
  { label: "BELA", value: "BELA", description: "Belagavi" },
  { label: "BELG", value: "BELG", description: "BELGAM" },
  { label: "BELL", value: "BELL", description: "BELLARY" },
  { label: "BENG", value: "BENG", description: "BENGALURU" },
  { label: "BERH", value: "BERH", description: "BERHAMPORE" },
  { label: "BETH", value: "BETH", description: "BETHORA GOA" },
  { label: "BETU", value: "BETU", description: "BETUL" },
  { label: "BEUA", value: "BEUA", description: "Beuar, Patna" },
  { label: "BGL", value: "BGL", description: "BANGALORE" },
  { label: "BGVI", value: "BGVI", description: "BELGAVI" },
  { label: "BHAD", value: "BHAD", description: "BHADOHI" },
  { label: "BHAG", value: "BHAG", description: "BHAGALPUR" },
  { label: "BHAN", value: "BHAN", description: "BHANDARA" },
  { label: "BHAR", value: "BHAR", description: "BHARATPUR" },
  { label: "BHAT", value: "BHAT", description: "BHAT" },
  { label: "BHAV", value: "BHAV", description: "BHAVNAGAR" },
  { label: "BHAW", value: "BHAW", description: "BHAWANIGARH" },
  { label: "BHAY", value: "BHAY", description: "BHAYANDR" },
  { label: "BHEL", value: "BHEL", description: "BHEL - HARIDWAR" },
  { label: "BHIL", value: "BHIL", description: "BHILWARA" },
  { label: "BHIN", value: "BHIN", description: "BHIND" },
  { label: "BHIW", value: "BHIW", description: "BHIWADI" },
  { label: "BHOJ", value: "BHOJ", description: "BHOJPUR" },
  { label: "BHOP", value: "BHOP", description: "BHOPAL" },
  { label: "BHR", value: "BHR", description: "BHIHAR" },
  { label: "BHRU", value: "BHRU", description: "BHARUCH" },
  { label: "BHUB", value: "BHUB", description: "BHUBANESHWAR" },
  { label: "BHUJ", value: "BHUJ", description: "BHUJ" },
  { label: "BHUP", value: "BHUP", description: "Bhupatwala, Haridwar" },
  { label: "BHUV", value: "BHUV", description: "BHUVANAGIRI" },
  { label: "BHW", value: "BHW", description: "BHIWANDI" },
  { label: "BIDA", value: "BIDA", description: "BIDAR" },
  { label: "BIJA", value: "BIJA", description: "BIJAPUR" },
  { label: "BIJN", value: "BIJN", description: "BIJNOR" },
  { label: "BIKR", value: "BIKR", description: "BIKANER" },
  { label: "BILA", value: "BILA", description: "BILASPUR" },
  { label: "BIRW", value: "BIRW", description: "BIRWADI" },
  { label: "BISR", value: "BISR", description: "BOISAR" },
  { label: "BOKA", value: "BOKA", description: "BOKARO" },
  { label: "BOLA", value: "BOLA", description: "BOLANGIR" },
  { label: "BONG", value: "BONG", description: "BONGAIGAON" },
  { label: "BORI", value: "BORI", description: "BORIVALI" },
  { label: "BOTA", value: "BOTA", description: "BOTAD" },
  { label: "BOUD", value: "BOUD", description: "BOUDH" },
  { label: "BRHI", value: "BRHI", description: "BARHI" },
  { label: "BRTW", value: "BRTW", description: "Barotiwala" },
  { label: "BRUC", value: "BRUC", description: "BHARUCH" },
  { label: "BRWL", value: "BRWL", description: "BARWALA" },
  { label: "BSTA", value: "BSTA", description: "BANAS KANTHA" },
  { label: "BUDA", value: "BUDA", description: "BUDAUN" },
  { label: "BUDG", value: "BUDG", description: "BUDGAM" },
  { label: "BUDH", value: "BUDH", description: "BUDH NAGAR" },
  { label: "BULA", value: "BULA", description: "BULANDSHAHAR" },
  { label: "BULD", value: "BULD", description: "BULDHANA" },
  { label: "BUND", value: "BUND", description: "BUNDI" },
  { label: "BUra", value: "BUra", description: "BUra" },
  { label: "BUrail", value: "BUrail", description: "BUrail" },
  { label: "BURD", value: "BURD", description: "BURDHANPUR" },
  { label: "BURH", value: "BURH", description: "BURHANPUR" },
  { label: "BURL", value: "BURL", description: "VSS MCH, BURLA" },
  { label: "BWN", value: "BWN", description: "BHIWANI" },
  { label: "CADD", value: "CADD", description: "CADDALORE" },
  { label: "CALI", value: "CALI", description: "CALICUT" },
  { label: "CHAM", value: "CHAM", description: "CHAMPAWAT" },
  { label: "CHAN", value: "CHAN", description: "CHANDAULI" },
  { label: "CHAR", value: "CHAR", description: "CHARKIDADRI" },
  { label: "Chat", value: "Chat", description: "Chattral" },
  { label: "CHDA", value: "CHDA", description: "CHARKI DADRI" },
  { label: "CHDO", value: "CHDO", description: "CHARAIDEO" },
  { label: "CHEM", value: "CHEM", description: "CHEMBUR,MUMBAI" },
  { label: "CHEN", value: "CHEN", description: "CHENNAI" },
  { label: "CHG", value: "CHG", description: "CHANDIGARH" },
  { label: "CHHA", value: "CHHA", description: "CHHATARPUR" },
  { label: "CHHI", value: "CHHI", description: "CHHINDWARA" },
  { label: "CHIK", value: "CHIK", description: "CHIKKABALLAPURA" },
  { label: "CHIN", value: "CHIN", description: "CHINA" },
  { label: "CHIT", value: "CHIT", description: "CHITTOOR" },
  { label: "CHR", value: "CHR", description: "CHANDRAPUR" },
  { label: "CHRU", value: "CHRU", description: "CHURU" },
  { label: "CHUR", value: "CHUR", description: "CHURU" },
  { label: "COCH", value: "COCH", description: "COCHIN" },
  { label: "COIM", value: "COIM", description: "COIMBATORE" },
  { label: "COON", value: "COON", description: "COONOOR" },
  { label: "CSR", value: "CSR", description: "CS-REWA" },
  { label: "CTRA", value: "CTRA", description: "CHHATRAL" },
  { label: "CUDD", value: "CUDD", description: "CUDDALORE" },
  { label: "CUTT", value: "CUTT", description: "CUTTACK" },
  { label: "D&N", value: "D&N", description: "DAMAN" },
  { label: "DADA", value: "DADA", description: "DADAR" },
  { label: "DADR", value: "DADR", description: "DADRA" },
  { label: "DAHJ", value: "DAHJ", description: "DAHEJ" },
  { label: "DAHO", value: "DAHO", description: "DAHOD" },
  { label: "DAKO", value: "DAKO", description: "DAKOR" },
  { label: "DAMM", value: "DAMM", description: "DAMMOSH" },
  { label: "DAMO", value: "DAMO", description: "DAMODARPUR (W.B)" },
  { label: "DAND", value: "DAND", description: "DANDELI" },
  { label: "DANH", value: "DANH", description: "DADRA AND NAGAR HAVELI" },
  { label: "DAR", value: "DAR", description: "DHAR" },
  { label: "DARJ", value: "DARJ", description: "DARJEELING" },
  { label: "DASK", value: "DASK", description: "DASKROI ,AHMEDABAD" },
  { label: "DATI", value: "DATI", description: "DATIA" },
  { label: "DAUS", value: "DAUS", description: "DAUSA" },
  { label: "DAVA", value: "DAVA", description: "DAVANAGERE" },
  { label: "DAVE", value: "DAVE", description: "DAVENGERE" },
  { label: "DEES", value: "DEES", description: "DEESA" },
  { label: "DEHA", value: "DEHA", description: "DEHARADUN" },
  { label: "DEL", value: "DEL", description: "DELHI" },
  { label: "DEOG", value: "DEOG", description: "DEOGARH" },
  { label: "DEOR", value: "DEOR", description: "DEORIA" },
  { label: "DERA", value: "DERA", description: "DERA BASSI" },
  { label: "DEVG", value: "DEVG", description: "DEVGADH BARIA" },
  { label: "DIST", value: "DIST", description: "DAHOD" },
  { label: "DEWA", value: "DEWA", description: "DEWAS" },
  { label: "DHAB", value: "DHAB", description: "DHABEL" },
  { label: "DHAK", value: "DHAK", description: "DHAKOLI (ZIRAKPUR)" },
  { label: "DHAM", value: "DHAM", description: "DHAMTARI" },
  { label: "DHAR", value: "DHAR", description: "DHARMAPURI" },
  { label: "DHEB", value: "DHEB", description: "DHEBAR ROAD- RAJKOT" },
  { label: "DHEN", value: "DHEN", description: "DHENKANAL" },
  { label: "DHM", value: "DHM", description: "DHAMPUR" },
  { label: "DHOL", value: "DHOL", description: "DHOLKA" },
  { label: "DHR", value: "DHR", description: "DEHRADUN" },
  { label: "DHUL", value: "DHUL", description: "DHULE" },
  { label: "DIBG", value: "DIBG", description: "DHUBRI" },
  { label: "DIBR", value: "DIBR", description: "DIBRUGARH" },
  { label: "DIND", value: "DIND", description: "DINDIGUL" },
  { label: "DIS", value: "DIS", description: "DISPUR" },
  { label: "DOHA", value: "DOHA", description: "DOHAD" },
  { label: "DUB", value: "DUB", description: "DUBAI" },
  { label: "DUM", value: "DUM", description: "DUMKA" },
  { label: "DUNG", value: "DUNG", description: "DUNGAPUR" },
  { label: "DURG", value: "DURG", description: "DURG" },
  { label: "DWAR", value: "DWAR", description: "DWARKA" },
  { label: "EDAP", value: "EDAP", description: "EDAPALLY" },
  { label: "EGMO", value: "EGMO", description: "Egmore, CHENNAI" },
  { label: "ELLI", value: "ELLI", description: "ELLISBRIDGE" },
  { label: "ERNA", value: "ERNA", description: "ERNAKULAM" },
  { label: "EROD", value: "EROD", description: "ERODE" },
  { label: "ETAH", value: "ETAH", description: "ETAH" },
  { label: "ETAW", value: "ETAW", description: "ETAWAH" },
  { label: "EZHU", value: "EZHU", description: "EZHUKONE" },
  { label: "FAIZ", value: "FAIZ", description: "FAIZABAD" },
  { label: "FARI", value: "FARI", description: "FARIDABAD" },
  { label: "FARR", value: "FARR", description: "FARRUKHABAD" },
  { label: "FATE", value: "FATE", description: "FATEHGARH SAHIB" },
  { label: "FATH", value: "FATH", description: "FATHEHABAD" },
  { label: "FAZI", value: "FAZI", description: "FAZILKA" },
  { label: "FERO", value: "FERO", description: "FEROZPUR" },
  { label: "FIRO", value: "FIRO", description: "FIROZABAD" },
  { label: "FPR", value: "FPR", description: "FATEHPUR" },
  { label: "FURS", value: "FURS", description: "FURSUNGI,PUNE" },
  { label: "GADA", value: "GADA", description: "GADAG" },
  { label: "GADC", value: "GADC", description: "GADCHIROLI" },
  { label: "GADH", value: "GADH", description: "GANDHIDHAM" },
  { label: "GADN", value: "GADN", description: "GANDHINAGAR" },
  { label: "GAJA", value: "GAJA", description: "GAJAPATI" },
  { label: "GAMD", value: "GAMD", description: "GAMDI" },
  { label: "GAN", value: "GAN", description: "GANJAM" },
  { label: "GANA", value: "GANA", description: "GANAUR" },
  { label: "GANG", value: "GANG", description: "GANGANAGAR" },
  { label: "Ganj", value: "Ganj", description: "Ganj Amethi" },
  { label: "GAUT", value: "GAUT", description: "GAUTAM BUDDHA NAGAR" },
  { label: "GAYA", value: "GAYA", description: "GAYA" },
  { label: "GEED", value: "GEED", description: "GEEDAM" },
  { label: "GERM", value: "GERM", description: "GERMANY" },
  { label: "GHAN", value: "GHAN", description: "GHANDHINAGAR" },
  { label: "GHAZ", value: "GHAZ", description: "GHAZIABAD" },
  { label: "GIDD", value: "GIDD", description: "GIDDERBAHA" },
  { label: "GIRS", value: "GIRS", description: "GIRSOMNATH" },
  { label: "GOA", value: "GOA", description: "GOA" },
  { label: "GODH", value: "GODH", description: "GODHRA" },
  { label: "GODO", value: "GODO", description: "Godown Etah" },
  { label: "GOHA", value: "GOHA", description: "GOHANA" },
  { label: "GOKA", value: "GOKA", description: "GOKAK" },
  { label: "GOND", value: "GOND", description: "GONDA" },
  { label: "GORA", value: "GORA", description: "GORAKHPUR" },
  { label: "GORE", value: "GORE", description: "GOREGAON" },
  { label: "GORG", value: "GORG", description: "GORGAON" },
  { label: "GPG", value: "GPG", description: "GOPALGANJ" },
  { label: "GRN", value: "GRN", description: "GREATER NOIDA" },
  { label: "GSON", value: "GSON", description: "GIR SOMNATH" },
  { label: "GTKP", value: "GTKP", description: "GHATKOPAR" },
  { label: "GTR", value: "GTR", description: "GUNTUR" },
  { label: "GUDS", value: "GUDS", description: "GURUDASPUR" },
  { label: "GUJA", value: "GUJA", description: "GUJARAT" },
  { label: "GUJR", value: "GUJR", description: "GUJRAT" },
  { label: "GULB", value: "GULB", description: "GULBARGA" },
  { label: "GUNA", value: "GUNA", description: "GUNA" },
  { label: "GURD", value: "GURD", description: "GURDASPUR" },
  { label: "GURG", value: "GURG", description: "GURGAON" },
  { label: "GURU", value: "GURU", description: "GURUGRAM" },
  { label: "GUW", value: "GUW", description: "GUWAHATHI" },
  { label: "GUWA", value: "GUWA", description: "GUWAHATI" },
  { label: "GWAL", value: "GWAL", description: "GWALIOR" },
  { label: "HALD", value: "HALD", description: "HALDWANI" },
  { label: "HALO", value: "HALO", description: "HALOL" },
  { label: "HAMI", value: "HAMI", description: "HAMIRPUR" },
  { label: "HANU", value: "HANU", description: "HANUMAKONDA" },
  { label: "HAPU", value: "HAPU", description: "HAPUR" },
  { label: "HARD", value: "HARD", description: "HARDA" },
  { label: "HARI", value: "HARI", description: "Harihar Chowk, RAJKOT" },
  { label: "HARY", value: "HARY", description: "HARYANA" },
  { label: "HASS", value: "HASS", description: "HASSAN" },
  { label: "HATH", value: "HATH", description: "HATHRAS" },
  { label: "HAVE", value: "HAVE", description: "HAVERI" },
  { label: "HAZA", value: "HAZA", description: "HAZARIBAG" },
  { label: "HIMA", value: "HIMA", description: "HIMACHAL PRADESH" },
  { label: "HING", value: "HING", description: "HINGAGHAT" },
  { label: "HISA", value: "HISA", description: "HISAR" },
  { label: "HOOG", value: "HOOG", description: "HOOGHLY" },
  { label: "HOSH", value: "HOSH", description: "HOSHIARPUR" },
  { label: "HOSU", value: "HOSU", description: "HOSUR" },
  { label: "HOWR", value: "HOWR", description: "HOWRAH" },
  { label: "HUBL", value: "HUBL", description: "HUBLI" },
  { label: "HUSS", value: "HUSS", description: "HUSSAINPUR" },
  { label: "HW", value: "HW", description: "HARIDWAR" },
  { label: "HYD", value: "HYD", description: "HYDERABAD" },
  { label: "IDUK", value: "IDUK", description: "IDUKKI" },
  { label: "IMMA", value: "IMMA", description: "IMMADIHALLI" },
  { label: "INDI", value: "INDI", description: "INDIA" },
  { label: "INDO", value: "INDO", description: "INDORE" },
  { label: "INDR", value: "INDR", description: "INDRAD" },
  { label: "ITAR", value: "ITAR", description: "ITARSI" },
  { label: "J&K", value: "J&K", description: "Jammu and Kashmir" },
  { label: "JAGA", value: "JAGA", description: "JAGATSINGHPUR" },
  { label: "JAGD", value: "JAGD", description: "JAGDALPUR" },
  { label: "JAI", value: "JAI", description: "JAIPUR" },
  { label: "JAJA", value: "JAJA", description: "JAJAPUR" },
  { label: "JALA", value: "JALA", description: "JALANDHAR" },
  { label: "JALG", value: "JALG", description: "JALGAON" },
  { label: "JALN", value: "JALN", description: "JALNA" },
  { label: "JALO", value: "JALO", description: "JALORE" },
  { label: "JALP", value: "JALP", description: "JALPAIGURI" },
  { label: "Jamm", value: "Jamm", description: "JammuandKashmir" },
  { label: "JAMM", value: "JAMM", description: "JAMMU" },
  { label: "JAMN", value: "JAMN", description: "JAMNAGAR" },
  { label: "JAMS", value: "JAMS", description: "JAMSHEDPUR" },
  { label: "JAMU", value: "JAMU", description: "JAMUI" },
  { label: "JANJ", value: "JANJ", description: "JANJGIR" },
  { label: "JANP", value: "JANP", description: "JANPATH" },
  { label: "JASH", value: "JASH", description: "JASHPUR" },
  { label: "JAUN", value: "JAUN", description: "JAUNPUR" },
  { label: "JBL", value: "JBL", description: "JABALPUR" },
  { label: "JGSP", value: "JGSP", description: "JAGDISHPUR" },
  { label: "JHAB", value: "JHAB", description: "JHABUA" },
  { label: "JHAJ", value: "JHAJ", description: "JHAJJAR" },
  { label: "JHAL", value: "JHAL", description: "JHALAWAR" },
  { label: "JHAN", value: "JHAN", description: "JHANSI" },
  { label: "JHAR", value: "JHAR", description: "JHARMAJRI" },
  { label: "JHOT", value: "JHOT", description: "Jhotwara" },
  { label: "JHUN", value: "JHUN", description: "JHUNJHUNU" },
  { label: "JIND", value: "JIND", description: "JIND" },
  { label: "JODH", value: "JODH", description: "JODHPUR" },
  { label: "JOGE", value: "JOGE", description: "Jogeshwari (West) - Mumbai" },
  { label: "JOUR", value: "JOUR", description: "JOURASI" },
  { label: "JPN", value: "JPN", description: "J.P.NAGAR" },
  { label: "JUNA", value: "JUNA", description: "JUNAGADH" },
  { label: "JWAL", value: "JWAL", description: "JWALAPUR" },
  { label: "K", value: "K", description: "K NAHGAR (CHENNAI)" },
  { label: "KACH", value: "KACH", description: "KACHCHH" },
  { label: "KAIL", value: "KAIL", description: "KAILY ROAD - BASTI" },
  { label: "KAIT", value: "KAIT", description: "KAITHAL" },
  { label: "KALA", value: "KALA", description: "KALA AMB" },
  { label: "KALI", value: "KALI", description: "KALIMPONG" },
  { label: "KALK", value: "KALK", description: "Kalka" },
  { label: "KALO", value: "KALO", description: "KALOL" },
  { label: "KALW", value: "KALW", description: "KALWAR(BHIWANDI" },
  { label: "KALY", value: "KALY", description: "Kalya" },
  { label: "KAM", value: "KAM", description: "KAMRUP" },
  { label: "KAMA", value: "KAMA", description: "KAMAREDDY" },
  { label: "KAMO", value: "KAMO", description: "KAMOTHE,NAVI MUMBAI,INDIA" },
  { label: "KANC", value: "KANC", description: "KANCHEEPURAM" },
  { label: "KAND", value: "KAND", description: "KANDIVALI" },
  { label: "KANG", value: "KANG", description: "KANGRA" },
  { label: "KANK", value: "KANK", description: "KANKER" },
  { label: "KANN", value: "KANN", description: "KANNAUJ" },
  { label: "KANP", value: "KANP", description: "KANPUR" },
  { label: "KANY", value: "KANY", description: "KANYAKUMARI" },
  { label: "KAPU", value: "KAPU", description: "KAPURTHALA" },
  { label: "KARA", value: "KARA", description: "KARAIKUDI" },
  { label: "Karg", value: "Karg", description: "Kargil" },
  { label: "KARI", value: "KARI", description: "KARIMNAGAR" },
  { label: "KARN", value: "KARN", description: "KARNAL" },
  { label: "KARU", value: "KARU", description: "KARUR" },
  { label: "KARW", value: "KARW", description: "KARWAR" },
  { label: "KASA", value: "KASA", description: "KASARGOD" },
  { label: "KASG", value: "KASG", description: "Kasganj" },
  { label: "KASH", value: "KASH", description: "KASHIPUR" },
  { label: "KASO", value: "KASO", description: "KASOLI" },
  { label: "KASU", value: "KASU", description: "KASAULI" },
  { label: "KATH", value: "KATH", description: "KATHUA" },
  { label: "KATN", value: "KATN", description: "KATNI" },
  { label: "KAUS", value: "KAUS", description: "KAUSHAMBI" },
  { label: "KAVI", value: "KAVI", description: "KAVI NAGAR,GHAZIABAD" },
  { label: "KAWA", value: "KAWA", description: "KAWARDHA" },
  { label: "KEND", value: "KEND", description: "KENDRAPADA" },
  { label: "KEON", value: "KEON", description: "KEONJHAR" },
  { label: "KERA", value: "KERA", description: "KERALA" },
  { label: "KHAM", value: "KHAM", description: "KHAMMAM" },
  { label: "KHAN", value: "KHAN", description: "KHANDALA" },
  { label: "KHAR", value: "KHAR", description: "KHARGAON" },
  { label: "KHED", value: "KHED", description: "KHEDA" },
  { label: "KHOR", value: "KHOR", description: "KHORDHA" },
  { label: "KHUR", value: "KHUR", description: "KHURDA" },
  { label: "KLHR", value: "KLHR", description: "KOLHAR" },
  { label: "KNCP", value: "KNCP", description: "KANCHIPURAM" },
  { label: "KNDW", value: "KNDW", description: "KHANDWA" },
  { label: "KNL", value: "KNL", description: "KURNOOL" },
  { label: "KOCH", value: "KOCH", description: "KOCHI" },
  { label: "KOLA", value: "KOLA", description: "KOLAR" },
  { label: "KOLH", value: "KOLH", description: "KOLHAPUR" },
  { label: "KOLK", value: "KOLK", description: "KOLKATA" },
  { label: "KOLL", value: "KOLL", description: "KOLLAM" },
  { label: "KOMP", value: "KOMP", description: "KOMPALLY" },
  { label: "KOPP", value: "KOPP", description: "KOPPAL" },
  { label: "KORA", value: "KORA", description: "KORAPUT" },
  { label: "KORB", value: "KORB", description: "KORBA" },
  { label: "KORE", value: "KORE", description: "KOREA" },
  { label: "KOSI", value: "KOSI", description: "KOSI" },
  { label: "KOTA", value: "KOTA", description: "KOTA" },
  { label: "KOTD", value: "KOTD", description: "Kotdwar" },
  { label: "Kotp", value: "Kotp", description: "Kotputli" },
  { label: "KOTT", value: "KOTT", description: "KOTTAYAM" },
  { label: "KOZH", value: "KOZH", description: "KOZHIKODE" },
  { label: "KRIS", value: "KRIS", description: "KRISHNAGIRI" },
  { label: "KRNT", value: "KRNT", description: "KARNATAKA" },
  { label: "KULL", value: "KULL", description: "KULLU" },
  { label: "KUMB", value: "KUMB", description: "KUMBHIRGRAM" },
  { label: "KUND", value: "KUND", description: "KUNDLI" },
  { label: "KURI", value: "KURI", description: "KURICHIKKARA" },
  { label: "KURU", value: "KURU", description: "KURUKSHETRA" },
  { label: "KUSH", value: "KUSH", description: "KUSHINAGAR" },
  { label: "KUTC", value: "KUTC", description: "KUTCH" },
  { label: "KUTT", value: "KUTT", description: "KUTTUR" },
  { label: "LALI", value: "LALI", description: "LALITPUR" },
  { label: "LALR", value: "LALR", description: "LALRU" },
  { label: "LANG", value: "LANG", description: "Langha Road, Dehradun" },
  { label: "LASH", value: "LASH", description: "LASHKAR -GWALIOR - MP" },
  { label: "LATH", value: "LATH", description: "LATHUR" },
  { label: "LATU", value: "LATU", description: "LATUR" },
  { label: "LEH", value: "LEH", description: "LEH LADAKH" },
  { label: "LEHL", value: "LEHL", description: "LEHLADAKH" },
  { label: "LIMB", value: "LIMB", description: "LIMBDI DISTT (SURENDRANAGAR)" },
  { label: "LUCK", value: "LUCK", description: "LUCKNOW" },
  { label: "LUDH", value: "LUDH", description: "LUDHIANA" },
  {
    label: "MACH",
    value: "MACH",
    description: "Machlishan Road- Jaunpur (U.P)",
  },
  { label: "MADH", value: "MADH", description: "Madhubani" },
  { label: "MADI", value: "MADI", description: "MADIKERE" },
  { label: "MADU", value: "MADU", description: "MADURAI" },
  { label: "MAHA", value: "MAHA", description: "MAHABUBNAGAR" },
  { label: "MAHB", value: "MAHB", description: "MAHBOOBNAGAR" },
  { label: "MAHE", value: "MAHE", description: "MAHESANA" },
  { label: "MAHO", value: "MAHO", description: "MAHOBA" },
  { label: "MAIN", value: "MAIN", description: "MAINPURI" },
  { label: "MAJH", value: "MAJH", description: "MAJHAULI.(SIWAN)" },
  { label: "MALE", value: "MALE", description: "MALERKOTLA" },
  { label: "MALK", value: "MALK", description: "MALKAGAJGIRI" },
  { label: "MALL", value: "MALL", description: "MALAPPURAM-KERALA" },
  { label: "MANA", value: "MANA", description: "MANAKPUR" },
  { label: "MANC", value: "MANC", description: "MANCHERIAL" },
  { label: "MAND", value: "MAND", description: "MANDI" },
  { label: "MANE", value: "MANE", description: "MANESAR" },
  { label: "MANG", value: "MANG", description: "MANGALORE" },
  { label: "MANI", value: "MANI", description: "MANIPUR" },
  { label: "MANJ", value: "MANJ", description: "MANJERI" },
  { label: "MANP", value: "MANP", description: "MANPURA" },
  { label: "MANS", value: "MANS", description: "MANSA" },
  { label: "MAPU", value: "MAPU", description: "MAPUSA" },
  { label: "MARR", value: "MARR", description: "MARRANWALA" },
  { label: "MASH", value: "MASH", description: "MASHURANTHAKAM" },
  { label: "MATO", value: "MATO", description: "MATODA" },
  { label: "MAUN", value: "MAUN", description: "MAUNATHBHANJAN" },
  { label: "MAWN", value: "MAWN", description: "MAWANA" },
  { label: "MAYI", value: "MAYI", description: "MAYILADUTHURAI" },
  { label: "MAYU", value: "MAYU", description: "MAYURBHANJ (ODISHA)" },
  { label: "MCH-", value: "MCH-", description: "MCH-INDORE" },
  { label: "MCH(", value: "MCH(", description: "MCH(M.P)" },
  { label: "MDK", value: "MDK", description: "MEDAK" },
  { label: "MDL", value: "MDL", description: "Mandal" },
  { label: "MDLA", value: "MDLA", description: "MANDLA" },
  { label: "MEDC", value: "MEDC", description: "MEDCHAL" },
  { label: "MEDI", value: "MEDI", description: "MEDINIPURDELHI" },
  { label: "MEER", value: "MEER", description: "MEERUT" },
  { label: "MEHA", value: "MEHA", description: "MEHATPUR" },
  { label: "MEHS", value: "MEHS", description: "MEHSANA" },
  { label: "MENT", value: "MENT", description: "MENTAL HEALTH INST. CUTTACK" },
  { label: "MERR", value: "MERR", description: "MERRUT" },
  { label: "MEWA", value: "MEWA", description: "MEWAT" },
  { label: "MHRS", value: "MHRS", description: "MAHARASHTRA" },
  { label: "MIRA", value: "MIRA", description: "Miraj" },
  { label: "MIRZ", value: "MIRZ", description: "MIRZAPUR" },
  { label: "MLAM", value: "MLAM", description: "MALAPPURAM-II" },
  { label: "MLMT", value: "MLMT", description: "MALAPPURAM-TIRUR" },
  { label: "MLPR", value: "MLPR", description: "MALAPPURAM" },
  { label: "MODI", value: "MODI", description: "MODINAGAR" },
  { label: "MOGA", value: "MOGA", description: "MOGA" },
  { label: "MOHA", value: "MOHA", description: "MOHALI" },
  { label: "MOHR", value: "MOHR", description: "MOHRA" },
  { label: "MORB", value: "MORB", description: "MORBI" },
  { label: "MORD", value: "MORD", description: "MORADABAD" },
  { label: "MORE", value: "MORE", description: "MORENA" },
  { label: "MOTI", value: "MOTI", description: "MOTIHARI" },
  { label: "MTHU", value: "MTHU", description: "MATHURA" },
  { label: "MUGH", value: "MUGH", description: "MUGHALSARAI(U.P.)" },
  { label: "MUJA", value: "MUJA", description: "Mujaffarnagar(UP)" },
  { label: "MUKT", value: "MUKT", description: "MUKTSAR" },
  { label: "MULI", value: "MULI", description: "MULI DISTT-SURENDRANAGAR" },
  { label: "MULU", value: "MULU", description: "MULUND" },
  { label: "MUM", value: "MUM", description: "MUMBAI" },
  { label: "MUMA", value: "MUMA", description: "MUMABI" },
  { label: "MUMB", value: "MUMB", description: "MUMB (EAST),MUMBAI" },
  { label: "MURS", value: "MURS", description: "MURSHIDABAD" },
  { label: "MUST", value: "MUST", description: "Mustfabad. Jwalapur" },
  { label: "MUZZ", value: "MUZZ", description: "MUZAFFARNAGAR" },
  { label: "MYAN", value: "MYAN", description: "MYANMAR" },
  { label: "MYSO", value: "MYSO", description: "MYSORE" },
  { label: "MYSU", value: "MYSU", description: "MYSURU" },
  { label: "MZFF", value: "MZFF", description: "MUZAFFARPUR" },
  { label: "NABA", value: "NABA", description: "NABARANGPUR" },
  { label: "NADI", value: "NADI", description: "NADIAD" },
  { label: "NAGA", value: "NAGA", description: "NAGARKURNOOL" },
  { label: "NAGE", value: "NAGE", description: "NAGERCOIL" },
  { label: "NAGP", value: "NAGP", description: "NAGPUR" },
  { label: "NAIN", value: "NAIN", description: "NAINITAL" },
  { label: "Nair", value: "Nair", description: "Nairobi" },
  { label: "NALA", value: "NALA", description: "NALAGARH" },
  { label: "NALG", value: "NALG", description: "NALGONDA" },
  { label: "NAMA", value: "NAMA", description: "NAMAKKAL" },
  { label: "NAND", value: "NAND", description: "NANDED" },
  { label: "NARE", value: "NARE", description: "NARELA" },
  { label: "NARI", value: "NARI", description: "NARIWALA" },
  { label: "NARM", value: "NARM", description: "NARMADA" },
  { label: "NARN", value: "NARN", description: "NARNAUL" },
  { label: "Naro", value: "Naro", description: "Naroli" },
  { label: "NARS", value: "NARS", description: "NARSINGHPUR" },
  { label: "NASH", value: "NASH", description: "NASHIK" },
  { label: "NASI", value: "NASI", description: "NASIK" },
  { label: "NAVA", value: "NAVA", description: "NAVAGAM" },
  { label: "NAVI", value: "NAVI", description: "NAVI MUMBAI" },
  { label: "NAVS", value: "NAVS", description: "NAVSARI" },
  { label: "NAYA", value: "NAYA", description: "NAYAGARH" },
  { label: "NDEL", value: "NDEL", description: "NEW DELHI" },
  { label: "NEEM", value: "NEEM", description: "NEEMUCH" },
  { label: "NELL", value: "NELL", description: "NELLORE" },
  { label: "NERA", value: "NERA", description: "NEEMRANA" },
  { label: "NEWD", value: "NEWD", description: "NEWDELHI" },
  { label: "NHSE", value: "NHSE", description: "NHAVA SHEVA" },
  { label: "NILG", value: "NILG", description: "NILGIRI" },
  { label: "NIMA", value: "NIMA", description: "NIMAR" },
  { label: "NIZA", value: "NIZA", description: "NIZAMABAD" },
  { label: "NOID", value: "NOID", description: "NOIDA" },
  { label: "NORT", value: "NORT", description: "NORTH 24 PARGANAS" },
  { label: "NUAP", value: "NUAP", description: "NUAPADA" },
  { label: "NUH", value: "NUH", description: "NUH" },
  { label: "NUNG", value: "NUNG", description: "NUNGAMPAKKAM-CHENNAI" },
  { label: "ODIS", value: "ODIS", description: "ODISHA" },
  { label: "ORIS", value: "ORIS", description: "ORISSA" },
  { label: "OSMA", value: "OSMA", description: "OSMANABAD" },
  { label: "OTTA", value: "OTTA", description: "OTTAPALAM" },
  { label: "PABH", value: "PABH", description: "PABHAT" },
  { label: "Pado", value: "Pado", description: "Padova" },
  { label: "PADU", value: "PADU", description: "PADUCHERRY" },
  { label: "PAHA", value: "PAHA", description: "PAHARI,PATNA" },
  { label: "PAK", value: "PAK", description: "PAKISTAN" },
  { label: "PALA", value: "PALA", description: "PALANPUR(GUJARAT)" },
  { label: "PALG", value: "PALG", description: "PALGHAR" },
  { label: "PALI", value: "PALI", description: "PALI" },
  { label: "PALL", value: "PALL", description: "PALLAKKAD" },
  { label: "PALW", value: "PALW", description: "PALWAL" },
  { label: "PANA", value: "PANA", description: "PANAMA" },
  { label: "PANC", value: "PANC", description: "PANCH MAHALS" },
  { label: "PANI", value: "PANI", description: "PANIPAT" },
  { label: "PANN", value: "PANN", description: "PANNA" },
  { label: "PANO", value: "PANO", description: "PANOLI" },
  { label: "PANV", value: "PANV", description: "PANVEL" },
  { label: "PAON", value: "PAON", description: "PAONTA SAHIB" },
  { label: "PARA", value: "PARA", description: "PARWADA" },
  { label: "PARB", value: "PARB", description: "PARBHANI" },
  { label: "PARE", value: "PARE", description: "PAREL MUMBAI-40" },
  { label: "PART", value: "PART", description: "PARTAPGARH" },
  { label: "PARW", value: "PARW", description: "PARWANOO" },
  { label: "PATA", value: "PATA", description: "PATAN" },
  { label: "Path", value: "Path", description: "Pathankot" },
  { label: "PATH", value: "PATH", description: "PATHANAMTHITTA" },
  { label: "PATI", value: "PATI", description: "PATIALA" },
  { label: "PATN", value: "PATN", description: "PATNA" },
  { label: "PATP", value: "PATP", description: "PATPARGANJ" },
  { label: "PATT", value: "PATT", description: "PATTARAVAKAM" },
  { label: "PAUR", value: "PAUR", description: "Pauri Garhwal" },
  { label: "PEEN", value: "PEEN", description: "PEENYA" },
  { label: "PERA", value: "PERA", description: "PERAMBALUR" },
  { label: "PERN", value: "PERN", description: "PERNEM" },
  { label: "PERU", value: "PERU", description: "PERUNDURAI" },
  { label: "PGS", value: "PGS", description: "PARGANAS" },
  { label: "PHAG", value: "PHAG", description: "PHAGWARA" },
  { label: "PHIL", value: "PHIL", description: "PHILLIPPINES" },
  { label: "PHUL", value: "PHUL", description: "PHULWARISHARIF - PATNA" },
  { label: "PIJO", value: "PIJO", description: "Pinjore" },
  { label: "PILI", value: "PILI", description: "PILIBHIT" },
  { label: "PIND", value: "PIND", description: "Pindi Street - Ludhiana" },
  { label: "PMCH", value: "PMCH", description: "PMCH, Patna" },
  { label: "PNCK", value: "PNCK", description: "PANCHKULA" },
  { label: "POAN", value: "POAN", description: "POANTA SAHIB" },
  { label: "POND", value: "POND", description: "PONDICHERRY" },
  { label: "PONT", value: "PONT", description: "PONTASAHIB" },
  { label: "PORB", value: "PORB", description: "PORBANDAR" },
  { label: "PORU", value: "PORU", description: "Porur chennai" },
  { label: "POWA", value: "POWA", description: "POWAI, MUMBAI" },
  { label: "PRAK", value: "PRAK", description: "PRAKASAM" },
  { label: "PRAT", value: "PRAT", description: "PRATAPGARH" },
  { label: "PRAY", value: "PRAY", description: "PRAYAGRAJ" },
  { label: "PTHA", value: "PTHA", description: "PATHANAMTHITTA" },
  { label: "PTMP", value: "PTMP", description: "PITHAMPUR" },
  { label: "PUDU", value: "PUDU", description: "PUDUKKOTTAI" },
  { label: "PULW", value: "PULW", description: "PULWAMA" },
  { label: "PUNC", value: "PUNC", description: "PUNCHKULA" },
  { label: "PUNE", value: "PUNE", description: "PUNE" },
  { label: "PUNJ", value: "PUNJ", description: "PUNJAB" },
  { label: "PURI", value: "PURI", description: "PURI" },
  { label: "PURN", value: "PURN", description: "PURNEA" },
  { label: "PURU", value: "PURU", description: "PURULIA" },
  { label: "PUTT", value: "PUTT", description: "PUTTUR" },
  { label: "RAEB", value: "RAEB", description: "RAEBAREILLY" },
  { label: "RAHA", value: "RAHA", description: "RAHANAL" },
  { label: "RAIC", value: "RAIC", description: "RAICHUR" },
  { label: "RAIG", value: "RAIG", description: "RAIGAD" },
  { label: "RAIP", value: "RAIP", description: "RAIPUR" },
  { label: "RAIS", value: "RAIS", description: "RAISEN" },
  { label: "RAJA", value: "RAJA", description: "RAJASTHAN" },
  { label: "RAJE", value: "RAJE", description: "RAJENDRANAGAR" },
  { label: "RAJG", value: "RAJG", description: "RAJGARH" },
  { label: "RAJK", value: "RAJK", description: "RAJKOT" },
  { label: "RAJN", value: "RAJN", description: "RAJNANDGAON" },
  { label: "RAJO", value: "RAJO", description: "RAJOURI GARDEN" },
  { label: "Rajp", value: "Rajp", description: "Rajpur" },
  { label: "RAJP", value: "RAJP", description: "RAJPURA" },
  { label: "RAJS", value: "RAJS", description: "RAJSAMAND" },
  { label: "RAMA", value: "RAMA", description: "RAMANAGARA" },
  { label: "RAMG", value: "RAMG", description: "RAMGARH" },
  { label: "RAMP", value: "RAMP", description: "RAMPUR" },
  { label: "RANC", value: "RANC", description: "RANCHI" },
  { label: "RANG", value: "RANG", description: "RANGA REDDY" },
  { label: "RANI", value: "RANI", description: "RANIPET" },
  { label: "RASA", value: "RASA", description: "RASAYANI" },
  { label: "RATL", value: "RATL", description: "RATLAM" },
  { label: "RATN", value: "RATN", description: "RATNAGIRI" },
  { label: "RAYA", value: "RAYA", description: "RAYAGADA" },
  { label: "REW", value: "REW", description: "REWA" },
  { label: "REWA", value: "REWA", description: "REWA" },
  { label: "REWARI", value: "REWARI", description: "REWARI" },
  { label: "RGH(", value: "RGH(", description: "RGH(CMO)" },
  { label: "RICH", value: "RICH", description: "RICHMOND ROAD-BANGALORE" },
  { label: "RISH", value: "RISH", description: "RISHIKESH" },
  { label: "RNGA", value: "RNGA", description: "K.V.RANGAREDDY" },
  { label: "ROBE", value: "ROBE", description: "ROBERTSGANJ" },
  { label: "ROHA", value: "ROHA", description: "ROHA" },
  { label: "ROHT", value: "ROHT", description: "ROHTAK" },
  { label: "RONG", value: "RONG", description: "Rongli" },
  { label: "ROOR", value: "ROOR", description: "ROORKEE" },
  { label: "ROPA", value: "ROPA", description: "ROPAR" },
  { label: "ROUR", value: "ROUR", description: "ROURKELA" },
  { label: "RUDR", value: "RUDR", description: "RUDRAPUR" },
  { label: "RUPN", value: "RUPN", description: "RUPNAGAR" },
  { label: "SABA", value: "SABA", description: "SABAR KANTHA" },
  { label: "SAGA", value: "SAGA", description: "SAGAR" },
  { label: "SAHA", value: "SAHA", description: "SAHARANPUR" },
  { label: "SAHE", value: "SAHE", description: "SAHEED BHAGAT SINGH NAGAR" },
  { label: "SAHI", value: "SAHI", description: "SAHIBABAD" },
  { label: "SALE", value: "SALE", description: "SALEM" },
  { label: "SAMA", value: "SAMA", description: "SAMASTIPUR-BIHAR" },
  { label: "SAMB", value: "SAMB", description: "SAMBA" },
  { label: "SANA", value: "SANA", description: "SANAND AHMEDABAD" },
  { label: "SANG", value: "SANG", description: "SANGRUR" },
  { label: "SANS", value: "SANS", description: "SANSARPUR" },
  { label: "SANT", value: "SANT", description: "SANT KABIR NAGAR" },
  { label: "SARA", value: "SARA", description: "SARAN" },
  { label: "SARI", value: "SARI", description: "SARIGAM" },
  { label: "SARK", value: "SARK", description: "SARKHEJ" },
  { label: "SAS", value: "SAS", description: "SAS NAGAR" },
  { label: "SASA", value: "SASA", description: "SASARAM" },
  { label: "SATA", value: "SATA", description: "SATARA" },
  { label: "SATN", value: "SATN", description: "SATNA" },
  { label: "SAWA", value: "SAWA", description: "SAWAI MADHOPUR" },
  { label: "SBLP", value: "SBLP", description: "SAMBALPUR" },
  { label: "SBSN", value: "SBSN", description: "Shahid Bhagat Singh Nagar" },
  { label: "SDOL", value: "SDOL", description: "SHAHDOL" },
  { label: "SEBA", value: "SEBA", description: "SEBASTOPOL" },
  { label: "SECU", value: "SECU", description: "SECUNDERABAD" },
  { label: "SEHO", value: "SEHO", description: "SEHORE" },
  { label: "SELA", value: "SELA", description: "SELAQUI,DEHRADUN" },
  { label: "SELV", value: "SELV", description: "SELVAPURAM" },
  { label: "SEON", value: "SEON", description: "SEONI" },
  { label: "SGAR", value: "SGAR", description: "SANGA REDDY (AP)" },
  { label: "SGRD", value: "SGRD", description: "SANGAREDDY" },
  { label: "Shah", value: "Shah", description: "ShahidBhagatSinghNagar" },
  { label: "SHAH", value: "SHAH", description: "SHAHJAHANPUR" },
  { label: "SHAJ", value: "SHAJ", description: "SHAJAPUR" },
  { label: "SHAK", value: "SHAK", description: "SHAKARPUR" },
  { label: "SHAM", value: "SHAM", description: "SHAMLI" },
  { label: "SHAR", value: "SHAR", description: "SHARANPUR" },
  { label: "SHEO", value: "SHEO", description: "SHEOPUR" },
  { label: "SHIL", value: "SHIL", description: "SHILLONG" },
  { label: "SHIM", value: "SHIM", description: "SHIMLA" },
  { label: "SHIS", value: "SHIS", description: "SHISHUBHAWAN CUTTACK" },
  { label: "SHIV", value: "SHIV", description: "SHIV PURI" },
  { label: "SHOL", value: "SHOL", description: "SHOLAVARAM" },
  { label: "SHOR", value: "SHOR", description: "SHORANUR" },
  { label: "SHRA", value: "SHRA", description: "SHRAVASTI" },
  { label: "SIDD", value: "SIDD", description: "SIDDIPET" },
  { label: "SIHO", value: "SIHO", description: "Sihor" },
  { label: "SIKA", value: "SIKA", description: "SIKAR" },
  { label: "SIKK", value: "SIKK", description: "SIKKIM" },
  { label: "SILC", value: "SILC", description: "SILCHAR (ASSAM)" },
  { label: "SILI", value: "SILI", description: "SILIGURI" },
  { label: "SILV", value: "SILV", description: "SILVASSA" },
  { label: "SIMO", value: "SIMO", description: "SIMOGA" },
  { label: "SIND", value: "SIND", description: "SINDHANUR" },
  { label: "SING", value: "SING", description: "SINGRAULI" },
  { label: "SIPR", value: "SIPR", description: "SITAPUR" },
  { label: "SIRM", value: "SIRM", description: "SIRMAUR" },
  { label: "SIRO", value: "SIRO", description: "SIROHI" },
  { label: "SIRS", value: "SIRS", description: "SIRSA" },
  { label: "SITA", value: "SITA", description: "SITARGUNJ" },
  { label: "SIVA", value: "SIVA", description: "SIVAGANGAI" },
  { label: "SIWA", value: "SIWA", description: "Siwan" },
  { label: "SLVM", value: "SLVM", description: "SHOLAVARAM" },
  { label: "SNGL", value: "SNGL", description: "SANGLI" },
  { label: "SNT", value: "SNT", description: "SONIPAT" },
  { label: "SOAL", value: "SOAL", description: "SOLAN" },
  { label: "SODA", value: "SODA", description: "SODALA,JAIPUR" },
  { label: "SOL", value: "SOL", description: "SOLAN" },
  { label: "SOLA", value: "SOLA", description: "SOLAPUR" },
  { label: "SONB", value: "SONB", description: "SONBHADRA" },
  { label: "SOPA", value: "SOPA", description: "SOUTH 24 PARGANAS" },
  { label: "SPSR", value: "SPSR", description: "SPSR NELLORE" },
  { label: "SRI", value: "SRI", description: "SRI GANGANAGAR" },
  { label: "SRIK", value: "SRIK", description: "SRIKAKULAM" },
  { label: "SRIN", value: "SRIN", description: "SRINAGAR" },
  { label: "SRLI", value: "SRLI", description: "SINGROULI" },
  { label: "SULT", value: "SULT", description: "SULTANPUR" },
  { label: "SUND", value: "SUND", description: "SUNDERGARH" },
  { label: "SURE", value: "SURE", description: "SURENDRANAGAR" },
  { label: "SURT", value: "SURT", description: "SURAT" },
  { label: "SURY", value: "SURY", description: "SURYAPET" },
  { label: "TALO", value: "TALO", description: "TALOJA" },
  { label: "TAMI", value: "TAMI", description: "Tami Tamilnadu" },
  { label: "TARA", value: "TARA", description: "TARAPUR" },
  { label: "TARN", value: "TARN", description: "TARN TARAN" },
  { label: "TAS", value: "TAS", description: "TASHKENT" },
  { label: "TAUR", value: "TAUR", description: "TAURU" },
  { label: "TEHR", value: "TEHR", description: "TEHRI GARHWAL" },
  { label: "TEHS", value: "TEHS", description: "TEHSIL- KHEDBRAHMA" },
  { label: "TELA", value: "TELA", description: "TELANGANA" },
  { label: "THAN", value: "THAN", description: "THANE" },
  { label: "THEN", value: "THEN", description: "THENI" },
  { label: "THIR", value: "THIR", description: "THIRUVALLUR" },
  { label: "THOO", value: "THOO", description: "THOOTHUKKUDI" },
  { label: "THRI", value: "THRI", description: "THRISSUR" },
  { label: "TIKA", value: "TIKA", description: "TIKAM GARGH" },
  { label: "TINS", value: "TINS", description: "TINSUKIA" },
  { label: "Tirl", value: "Tirl", description: "Tirlokpur" },
  { label: "Tiru", value: "Tiru", description: "Tiruvallur" },
  { label: "TIRU", value: "TIRU", description: "TIRUNELVELI" },
  { label: "TKGH", value: "TKGH", description: "TIKAMGARH" },
  { label: "TOHA", value: "TOHA", description: "TOHANA" },
  { label: "TONK", value: "TONK", description: "TONK" },
  { label: "TRCL", value: "TRCL", description: "TIRUCHIRAPALLI" },
  { label: "TRIC", value: "TRIC", description: "TRICHY(TAMIL NADU)" },
  { label: "TRIP", value: "TRIP", description: "TRIPUNITHURA(KERALA)" },
  { label: "TRIV", value: "TRIV", description: "TRIVANDRUM" },
  { label: "TRUP", value: "TRUP", description: "THIRUVANANTHAPURAM" },
  { label: "TRUV", value: "TRUV", description: "TRIUVALLUR" },
  { label: "TUGH", value: "TUGH", description: "TUGHLAKABAD" },
  { label: "TULJ", value: "TULJ", description: "TULJAPUR" },
  { label: "TUMA", value: "TUMA", description: "TUMAKURU" },
  { label: "TUMK", value: "TUMK", description: "TUMKUR" },
  { label: "UDAI", value: "UDAI", description: "UDAIPUR" },
  { label: "UDHA", value: "UDHA", description: "UDHAM SINGH NAGAR" },
  { label: "UDUP", value: "UDUP", description: "UDUPI" },
  { label: "UGML", value: "UGML", description: "UDHAGAMANDALAM" },
  { label: "UJJA", value: "UJJA", description: "UJJAIN" },
  { label: "UKRA", value: "UKRA", description: "UKRAINE" },
  { label: "ULHA", value: "ULHA", description: "ULHASNAGAR" },
  { label: "UMAR", value: "UMAR", description: "UMARIA" },
  { label: "UMER", value: "UMER", description: "UMERGAON" },
  { label: "UNA", value: "UNA", description: "UNA" },
  { label: "UNJH", value: "UNJH", description: "UNJHA (N.G)" },
  { label: "UNNA", value: "UNNA", description: "UNNAO" },
  { label: "UP", value: "UP", description: "UTTAR PRADESH" },
  { label: "UTTR", value: "UTTR", description: "UTTRAKHAND" },
  { label: "VADO", value: "VADO", description: "VADODRA" },
  { label: "VALS", value: "VALS", description: "VALSAD" },
  { label: "VAPI", value: "VAPI", description: "VAPI" },
  { label: "VARA", value: "VARA", description: "VARANASI" },
  { label: "VASA", value: "VASA", description: "VASAI" },
  { label: "VDRA", value: "VDRA", description: "VADODARA" },
  { label: "VEJA", value: "VEJA", description: "VEJALPOR" },
  { label: "VELL", value: "VELL", description: "VELLORE" },
  { label: "VEMA", value: "VEMA", description: "VEMAGIRI" },
  { label: "VERN", value: "VERN", description: "VERNA" },
  { label: "VEUR", value: "VEUR", description: "VEURPALGHAR EAST" },
  { label: "VICT", value: "VICT", description: "VICTORIA MAHE SEYCHELLES" },
  { label: "VIDI", value: "VIDI", description: "VIDISHA" },
  { label: "VIKA", value: "VIKA", description: "VIKARABAD" },
  { label: "VIKH", value: "VIKH", description: "VIKHROLI (MUMBAI)" },
  { label: "VILE", value: "VILE", description: "VILE PARLE" },
  { label: "VILL", value: "VILL", description: "VILLUPURAM" },
  { label: "VIRU", value: "VIRU", description: "VIRUDHUNAGAR" },
  { label: "Vish", value: "Vish", description: "Vishakhapatnam" },
  { label: "VIZG", value: "VIZG", description: "VIZIANAGARAM" },
  { label: "VJW", value: "VJW", description: "VIJAYAWADA" },
  { label: "VSP", value: "VSP", description: "VISAKHAPATNAM" },
  { label: "Wadh", value: "Wadh", description: "Wadhwan" },
  { label: "WADI", value: "WADI", description: "WADI" },
  { label: "WANA", value: "WANA", description: "WANAPARTHY" },
  { label: "WARD", value: "WARD", description: "WARDHA" },
  { label: "WARL", value: "WARL", description: "WARANGAL" },
  { label: "WAYN", value: "WAYN", description: "WAYANAD" },
  { label: "WBL", value: "WBL", description: "WEST BENGAL" },
  { label: "WSM", value: "WSM", description: "WASHIM" },
  { label: "YADA", value: "YADA", description: "YADADRI BHUVANAGIRI" },
  { label: "YADG", value: "YADG", description: "YADGIRI" },
  { label: "YAMU", value: "YAMU", description: "YAMUNA NAGAR" },
  { label: "YAVA", value: "YAVA", description: "YAVATMAL" },
  { label: "ZRK", value: "ZRK", description: "ZIRAKPUR" },
];

export const paymentTerm = [
  {
    label: "0001",
    value: "0001",
    description: "Pay immediately w/o deduction",
  },
  { label: "Y001", value: "Y001", description: "15 Days from Purchase Date" },
  { label: "Y002", value: "Y002", description: "30 Days from Purchase Date" },
  { label: "Y003", value: "Y003", description: "45 Days from Purchase Date" },
  { label: "Y004", value: "Y004", description: "60 Days from Purchase Date" },
  { label: "Y005", value: "Y005", description: "Against Letter of Credit" },
  { label: "Y006", value: "Y006", description: "100% Advance" },
  {
    label: "Y007",
    value: "Y007",
    description: "75% Advance & 25% against Proforma Invoice",
  },
  {
    label: "Y008",
    value: "Y008",
    description: "50% Advance & 50% against Proforma Invoice",
  },
  {
    label: "Y009",
    value: "Y009",
    description: "25% Advance & 75% against Proforma Invoice",
  },
  {
    label: "Y010",
    value: "Y010",
    description: "40% adv. and balance after del.",
  },
  {
    label: "Y011",
    value: "Y011",
    description: "50% Advance & 50% After delivery",
  },
  {
    label: "Y012",
    value: "Y012",
    description: "60% adv. and balance after del.",
  },
  {
    label: "Y013",
    value: "Y013",
    description: "70% adv. and balance after del.",
  },
  {
    label: "Y014",
    value: "Y014",
    description: "80% adv. and balance after del.",
  },
  {
    label: "Y015",
    value: "Y015",
    description: "20% adv.with PO, 65% against PI & bal.after del.",
  },
  {
    label: "Y016",
    value: "Y016",
    description: "90% against PI & 10% after successful installation",
  },
  {
    label: "Y017",
    value: "Y017",
    description: "30% adv., 50%  PI, 10% instal.&bal. after validate",
  },
  {
    label: "Y018",
    value: "Y018",
    description: "30% adv. PO, 60% PI, 10% after successful instal",
  },
  {
    label: "Y019",
    value: "Y019",
    description: "33%  adv. PO & bal. after successful trial",
  },
  { label: "Y020", value: "Y020", description: "7 days after delivery" },
  { label: "Y021", value: "Y021", description: "15 days after delivery" },
  { label: "Y022", value: "Y022", description: "30 days after delivery" },
  { label: "Y023", value: "Y023", description: "45 days after delivery" },
  { label: "Y024", value: "Y024", description: "60 days after delivery" },
  { label: "Y025", value: "Y025", description: "90 days after delivery" },
  { label: "Y026", value: "Y026", description: "120 days after delivery" },
  {
    label: "Y027",
    value: "Y027",
    description: "Pay in 5 partial 30% 1st,30%2nd,30%3rd,5%4th,5%5th",
  },
  {
    label: "Y028",
    value: "Y028",
    description: "25% adv.with PO, 65% against PI & bal.after del",
  },
  {
    label: "Y029",
    value: "Y029",
    description: "100% Advance against Proforma Invoice",
  },
  { label: "Y030", value: "Y030", description: "100% Advance by TT" },
  {
    label: "Y031",
    value: "Y031",
    description: "30% Advance & 70% against Proforma Invoice",
  },
  {
    label: "Y032",
    value: "Y032",
    description: "25% adv. PO, 55% PI, 20% after successful instal",
  },
  { label: "Y033", value: "Y033", description: "CASH PAYMENT" },
  {
    label: "Y034",
    value: "Y034",
    description: "25% acc PO, 40%  PI. 25% inst & 10% bank guarantee",
  },
  {
    label: "Y035",
    value: "Y035",
    description: "40% adv, 40% aftr delivry, 20% aginst satisfactory",
  },
  {
    label: "Y036",
    value: "Y036",
    description: "15 Days after Completion of Work",
  },
  {
    label: "Y037",
    value: "Y037",
    description: "30 Days after Completion of Work",
  },
  {
    label: "Y038",
    value: "Y038",
    description: "100% Advance against Work Order",
  },
  {
    label: "Y039",
    value: "Y039",
    description: "40% adv. and balance after completion",
  },
  {
    label: "Y040",
    value: "Y040",
    description: "50% adv. and balance after completion",
  },
  {
    label: "Y041",
    value: "Y041",
    description: "60% adv. and balance after completion",
  },
  {
    label: "Y042",
    value: "Y042",
    description: "70% adv. and balance after completion",
  },
  {
    label: "Y043",
    value: "Y043",
    description: "80% adv. and balance after completion",
  },
  {
    label: "Y044",
    value: "Y044",
    description: "100% After Completion of Work",
  },
  {
    label: "Y045",
    value: "Y045",
    description: "Advance in 2 equal Installment",
  },
  { label: "Y046", value: "Y046", description: "Payment on C.O.D basis" },
  { label: "Y047", value: "Y047", description: "75 Days After Delivery" },
  { label: "Y048", value: "Y048", description: "20 Days after Delivery" },
  {
    label: "Y049",
    value: "Y049",
    description: "90 Days From Airway Bill or B/L.",
  },
  { label: "Y050", value: "Y050", description: "60 Days PDC." },
  { label: "Y051", value: "Y051", description: "21 Days PDC." },
  { label: "Y052", value: "Y052", description: "30 Days PDC." },
  {
    label: "Y053",
    value: "Y053",
    description: "60 Days From Airway Bill or B/L.",
  },
  {
    label: "Y054",
    value: "Y054",
    description: "20% Adv. and Balance after Del.",
  },
  {
    label: "Y055",
    value: "Y055",
    description: "25% Advance and balance 30 days PDC",
  },
  { label: "Y056", value: "Y056", description: "Quarterly Advance" },
  { label: "Y057", value: "Y057", description: "100% Against Delivery" },
  {
    label: "Y058",
    value: "Y058",
    description: "50% Advance against PI & 50% after 6 month.",
  },
  {
    label: "Y059",
    value: "Y059",
    description: "30 Days after submission of invoice",
  },
  {
    label: "Y060",
    value: "Y060",
    description: "100% After submission of Reports.",
  },
  {
    label: "Y061",
    value: "Y061",
    description: "Against Invoice of Subsequent Month of Invoice",
  },
  {
    label: "Y062",
    value: "Y062",
    description: "50% after Inv. & 50% after 6 month Submit Inv.",
  },
  {
    label: "Y063",
    value: "Y063",
    description: "50% Adv.Ag.PO.25%After Reg 25% draft study Report",
  },
  {
    label: "Y064",
    value: "Y064",
    description: "20% Advance & 80% After 30 days from Invoice date",
  },
  { label: "Y065", value: "Y065", description: "After 6 months" },
  { label: "Y066", value: "Y066", description: "45 DAYS PDC" },
  {
    label: "Y067",
    value: "Y067",
    description: "15 Days after submission of Invoice",
  },
  { label: "Y070", value: "Y070", description: "90 DAYS FROM DATE OF INVOICE" },
  {
    label: "Y071",
    value: "Y071",
    description: "10% advance & balance after 35 days from Inv.date",
  },
  {
    label: "Y072",
    value: "Y072",
    description: "50% Adv.&25% on del. & 25% within 10day after del.",
  },
  { label: "Y073", value: "Y073", description: "After Delivery" },
  { label: "Y074", value: "Y074", description: "Against Bank Gurantee" },
  { label: "Y075", value: "Y075", description: "35 days from Invoice Date" },
  { label: "Y076", value: "Y076", description: "10 days After Delivery" },
  {
    label: "Y077",
    value: "Y077",
    description: "45 days PDC from date of Invoice",
  },
  { label: "Y078", value: "Y078", description: "After 45 days from delivery" },
  { label: "Y079", value: "Y079", description: "60 Days after Goods Receipt" },
  { label: "Y080", value: "Y080", description: "As per Contract" },
  { label: "Z173", value: "Z173", description: "DP AT SIGHT" },
  { label: "Z174", value: "Z174", description: "DP AT 30 DAYS" },
];

export const paymentTermData = [
  {
    "label": "Pay immediately w/o deduction",
    "value": "0001",
    "description": "Pay immediately w/o deduction"
  },
  {
    "label": "15 Days from Invoice Date",
    "value": "Y001",
    "description": "15 Days from Invoice Date"
  },
  {
    "label": "30 Days from Invoice Date",
    "value": "Y002",
    "description": "30 Days from Invoice Date"
  },
  {
    "label": "45 Days from Invoice Date",
    "value": "Y003",
    "description": "45 Days from Invoice Date"
  },
  {
    "label": "60 Days from Invoice Date",
    "value": "Y004",
    "description": "60 Days from Invoice Date"
  },
  {
    "label": "100% Advance",
    "value": "Y006",
    "description": "100% Advance"
  },
  {
    "label": "75% Advance & 25% against Proforma Invoice",
    "value": "Y007",
    "description": "75% Advance & 25% against Proforma Invoice"
  },
  {
    "label": "50% Advance & 50% against Proforma Invoice",
    "value": "Y008",
    "description": "50% Advance & 50% against Proforma Invoice"
  },
  {
    "label": "25% Advance & 75% against Proforma Invoice",
    "value": "Y009",
    "description": "25% Advance & 75% against Proforma Invoice"
  },
  {
    "label": "40% adv. and balance after del.",
    "value": "Y010",
    "description": "40% adv. and balance after del."
  },
  {
    "label": "50% Advance & 50% After delivery",
    "value": "Y011",
    "description": "50% Advance & 50% After delivery"
  },
  {
    "label": "60% adv. and balance after del.",
    "value": "Y012",
    "description": "60% adv. and balance after del."
  },
  {
    "label": "70% adv. and balance after del.",
    "value": "Y013",
    "description": "70% adv. and balance after del."
  },
  {
    "label": "80% adv. and balance after del.",
    "value": "Y014",
    "description": "80% adv. and balance after del."
  },
  {
    "label": "20% adv.with PO, 65% against PI & bal.after del.",
    "value": "Y015",
    "description": "20% adv.with PO, 65% against PI & bal.after del."
  },
  {
    "label": "90% against PI & 10% after successful installation",
    "value": "Y016",
    "description": "90% against PI & 10% after successful installation"
  },
  {
    "label": "30% adv., 50%  PI, 10% instal.&bal. after validate",
    "value": "Y017",
    "description": "30% adv., 50%  PI, 10% instal.&bal. after validate"
  },
  {
    "label": "30% adv. PO, 60% PI, 10% after successful instal",
    "value": "Y018",
    "description": "30% adv. PO, 60% PI, 10% after successful instal"
  },
  {
    "label": "33%  adv. PO & bal. after successful trial",
    "value": "Y019",
    "description": "33%  adv. PO & bal. after successful trial"
  },
  {
    "label": "7 days after delivery",
    "value": "Y020",
    "description": "7 days after delivery"
  },
  {
    "label": "15 days after delivery",
    "value": "Y021",
    "description": "15 days after delivery"
  },
  {
    "label": "30 days after delivery",
    "value": "Y022",
    "description": "30 days after delivery"
  },
  {
    "label": "45 days after delivery",
    "value": "Y023",
    "description": "45 days after delivery"
  },
  {
    "label": "60 days after delivery",
    "value": "Y024",
    "description": "60 days after delivery"
  },
  {
    "label": "90 days after delivery",
    "value": "Y025",
    "description": "90 days after delivery"
  },
  {
    "label": "120 days after delivery",
    "value": "Y026",
    "description": "120 days after delivery"
  },
  {
    "label": "Pay in 5 partial 30% 1st,30%2nd,30%3rd,5%4th,5%5th",
    "value": "Y027",
    "description": "Pay in 5 partial 30% 1st,30%2nd,30%3rd,5%4th,5%5th"
  },
  {
    "label": "25% adv.with PO, 65% against PI & bal.after del",
    "value": "Y028",
    "description": "25% adv.with PO, 65% against PI & bal.after del"
  },
  {
    "label": "100% Advance against Proforma Invoice",
    "value": "Y029",
    "description": "100% Advance against Proforma Invoice"
  },
  {
    "label": "100% Advance by TT",
    "value": "Y030",
    "description": "100% Advance by TT"
  },
  {
    "label": "30% Advance & 70% against Proforma Invoice",
    "value": "Y031",
    "description": "30% Advance & 70% against Proforma Invoice"
  },
  {
    "label": "25% adv. PO, 55% PI, 20% after successful instal",
    "value": "Y032",
    "description": "25% adv. PO, 55% PI, 20% after successful instal"
  },
  {
    "label": "CASH PAYMENT",
    "value": "Y033",
    "description": "CASH PAYMENT"
  },
  {
    "label": "25% acc PO, 40%  PI. 25% inst & 10% bank guarantee",
    "value": "Y034",
    "description": "25% acc PO, 40%  PI. 25% inst & 10% bank guarantee"
  },
  {
    "label": "40% adv, 40% aftr delivry, 20% aginst satisfactory",
    "value": "Y035",
    "description": "40% adv, 40% aftr delivry, 20% aginst satisfactory"
  },
  {
    "label": "15 Days after Completion of Work",
    "value": "Y036",
    "description": "15 Days after Completion of Work"
  },
  {
    "label": "30 Days after Completion of Work",
    "value": "Y037",
    "description": "30 Days after Completion of Work"
  },
  {
    "label": "100% Advance against Work Order",
    "value": "Y038",
    "description": "100% Advance against Work Order"
  },
  {
    "label": "40% adv. and balance after completion",
    "value": "Y039",
    "description": "40% adv. and balance after completion"
  },
  {
    "label": "50% adv. and balance after completion",
    "value": "Y040",
    "description": "50% adv. and balance after completion"
  },
  {
    "label": "60% adv. and balance after completion",
    "value": "Y041",
    "description": "60% adv. and balance after completion"
  },
  {
    "label": "70% adv. and balance after completion",
    "value": "Y042",
    "description": "70% adv. and balance after completion"
  },
  {
    "label": "80% adv. and balance after completion",
    "value": "Y043",
    "description": "80% adv. and balance after completion"
  },
  {
    "label": "100% After Completion of Work",
    "value": "Y044",
    "description": "100% After Completion of Work"
  },
  {
    "label": "Advance in 2 equal Installment",
    "value": "Y045",
    "description": "Advance in 2 equal Installment"
  },
  {
    "label": "Payment on C.O.D basis",
    "value": "Y046",
    "description": "Payment on C.O.D basis"
  },
  {
    "label": "75 Days After Delivery",
    "value": "Y047",
    "description": "75 Days After Delivery"
  },
  {
    "label": "20 Days after Delivery",
    "value": "Y048",
    "description": "20 Days after Delivery"
  },
  {
    "label": "90 Days From Airway Bill or B/L",
    "value": "Y049",
    "description": "90 Days From Airway Bill or B/L"
  },
  {
    "label": "60 Days PDC",
    "value": "Y050",
    "description": "60 Days PDC"
  },
  {
    "label": "21 Days PDC",
    "value": "Y051",
    "description": "21 Days PDC"
  },
  {
    "label": "30 Days PDC",
    "value": "Y052",
    "description": "30 Days PDC"
  },
  {
    "label": "60 Days From Airway Bill or B/L",
    "value": "Y053",
    "description": "60 Days From Airway Bill or B/L"
  },
  {
    "label": "20% Adv. and Balance after Del.",
    "value": "Y054",
    "description": "20% Adv. and Balance after Del."
  },
  {
    "label": "25% Advance and balance 30 days PDC",
    "value": "Y055",
    "description": "25% Advance and balance 30 days PDC"
  },
  {
    "label": "Quarterly Advance",
    "value": "Y056",
    "description": "Quarterly Advance"
  },
  {
    "label": "100% Against Delivery",
    "value": "Y057",
    "description": "100% Against Delivery"
  },
  {
    "label": "50% Advance against PI & 50% after 6 month",
    "value": "Y058",
    "description": "50% Advance against PI & 50% after 6 month"
  },
  {
    "label": "30 Days after submission of invoice",
    "value": "Y059",
    "description": "30 Days after submission of invoice"
  },
  {
    "label": "100% After submission of Reports",
    "value": "Y060",
    "description": "100% After submission of Reports"
  },
  {
    "label": "Against Invoice of Subsequent Month of Invoice",
    "value": "Y061",
    "description": "Against Invoice of Subsequent Month of Invoice"
  },
  {
    "label": "50% after Inv. & 50% after 6 month Submit Inv.",
    "value": "Y062",
    "description": "50% after Inv. & 50% after 6 month Submit Inv."
  },
  {
    "label": "50% Adv.Ag.PO.25%After Reg 25% draft study Report",
    "value": "Y063",
    "description": "50% Adv.Ag.PO.25%After Reg 25% draft study Report"
  },
  {
    "label": "20% Advance & 80% After 30 days from Invoice date",
    "value": "Y064",
    "description": "20% Advance & 80% After 30 days from Invoice date"
  },
  {
    "label": "After 6 months",
    "value": "Y065",
    "description": "After 6 months"
  },
  {
    "label": "45 DAYS PDC",
    "value": "Y066",
    "description": "45 DAYS PDC"
  },
  {
    "label": "15 Days after submission of Invoice",
    "value": "Y067",
    "description": "15 Days after submission of Invoice"
  },
  {
    "label": "90 DAYS FROM DATE OF INVOICE",
    "value": "Y070",
    "description": "90 DAYS FROM DATE OF INVOICE"
  },
  {
    "label": "10% advance & balance after 35 days from Inv.date",
    "value": "Y071",
    "description": "10% advance & balance after 35 days from Inv.date"
  },
  {
    "label": "50% Adv.&25% on del. & 25% within 10day after del.",
    "value": "Y072",
    "description": "50% Adv.&25% on del. & 25% within 10day after del."
  },
  {
    "label": "After Delivery",
    "value": "Y073",
    "description": "After Delivery"
  },
  {
    "label": "Against Bank Guarantee",
    "value": "Y074",
    "description": "Against Bank Guarantee"
  },
  {
    "label": "35 days from Invoice Date",
    "value": "Y075",
    "description": "35 days from Invoice Date"
  },
  {
    "label": "10 days After Delivery",
    "value": "Y076",
    "description": "10 days After Delivery"
  },
  {
    "label": "45 days PDC from date of Invoice",
    "value": "Y077",
    "description": "45 days PDC from date of Invoice"
  },
  {
    "label": "50 days from Invoice date",
    "value": "Y078",
    "description": "50 days from Invoice date"
  },
  {
    "label": "52 days from Invoice date",
    "value": "Y079",
    "description": "52 days from Invoice date"
  },
  {
    "label": "40% ADV+ BAL 60% Before Dispatch",
    "value": "Y080",
    "description": "40% ADV+ BAL 60% Before Dispatch"
  },
  {
    "label": "Adv.25K per product at Order&Bal at Dispatch",
    "value": "Y081",
    "description": "Adv.25K per product at Order&Bal at Dispatch"
  },
  {
    "label": "10% Adv+Bal.30 Days PDC Bef.Dispatch Agst PI",
    "value": "Y082",
    "description": "10% Adv+Bal.30 Days PDC Bef.Dispatch Agst PI"
  },
  {
    "label": "40%Adv.with Order&60% 45 days PDC Before Dispatch",
    "value": "Y083",
    "description": "40%Adv.with Order&60% 45 days PDC Before Dispatch"
  },
  {
    "label": "10%ADV+BAL. 60 DAYS PDC BEF DISP AGST PI",
    "value": "Y084",
    "description": "10%ADV+BAL. 60 DAYS PDC BEF DISP AGST PI"
  },
  {
    "label": "15%ADV against PO+BAL.45 DAYS PDC BEF DISP AGST PI",
    "value": "Y085",
    "description": "15%ADV against PO+BAL.45 DAYS PDC BEF DISP AGST PI"
  },
  {
    "label": "75 days PDC",
    "value": "Y086",
    "description": "75 days PDC"
  },
  {
    "label": "25% Adv with and bal 15 days credit",
    "value": "Y087",
    "description": "25% Adv with and bal 15 days credit"
  },
  {
    "label": "20%ADV against PO BAL.45 DAYS PDC BEF DISP AGST PI",
    "value": "Y088",
    "description": "20%ADV against PO BAL.45 DAYS PDC BEF DISP AGST PI"
  },
  {
    "label": "50%Adv.with order &50% 30 Days PDC Before Dispatch",
    "value": "Y089",
    "description": "50%Adv.with order &50% 30 Days PDC Before Dispatch"
  },
  {
    "label": "30 Days From Airway Bill",
    "value": "Y090",
    "description": "30 Days From Airway Bill"
  },
  {
    "label": "22 Days After Delivery",
    "value": "Y091",
    "description": "22 Days After Delivery"
  },
  {
    "label": "70 Days from Posting date",
    "value": "Y092",
    "description": "70 Days from Posting date"
  },
  {
    "label": "Payment against LR",
    "value": "Y093",
    "description": "Payment against LR"
  },
  {
    "label": "Immediate Payment after testing of material",
    "value": "Y094",
    "description": "Immediate Payment after testing of material"
  },
  {
    "label": "30 days PDC from the date of Inv.",
    "value": "Y095",
    "description": "30 days PDC from the date of Inv."
  },
  {
    "label": "60 days PDC from the date of inv.",
    "value": "Y096",
    "description": "60 days PDC from the date of inv."
  },
  {
    "label": "90 Days PDC from the date of Inv.",
    "value": "Y097",
    "description": "90 Days PDC from the date of Inv."
  },
  {
    "label": "10% Advance & 90% against delivery",
    "value": "Y098",
    "description": "10% Advance & 90% against delivery"
  },
  {
    "label": "25% Advance & 75% After Delivery",
    "value": "Y099",
    "description": "25% Advance & 75% After Delivery"
  },
  {
    "label": "Payment release after rept of formulation payment",
    "value": "Y100",
    "description": "Payment release after rept of formulation payment"
  },
  {
    "label": "LC AT SIGHT",
    "value": "Y101",
    "description": "LC AT SIGHT"
  },
  {
    "label": "Within 5 days",
    "value": "Y102",
    "description": "Within 5 days"
  },
  {
    "label": "120 days credit from date of invoice",
    "value": "Y103",
    "description": "120 days credit from date of invoice"
  },
  {
    "label": "50% ADV&50% AFTER DELIVERY&SUCCESSFUL TRIAL",
    "value": "Y111",
    "description": "50% ADV&50% AFTER DELIVERY&SUCCESSFUL TRIAL"
  },
  {
    "label": "50% Adv & Bal.After 7 days Delivery",
    "value": "Y112",
    "description": "50% Adv & Bal.After 7 days Delivery"
  },
  {
    "label": "25%Adv,50%within 15days&25%After Successful Instal",
    "value": "Y113",
    "description": "25%Adv,50%within 15days&25%After Successful Instal"
  },
  {
    "label": "After Successful Installation",
    "value": "Y114",
    "description": "After Successful Installation"
  },
  {
    "label": "25%Adv,65%Agst Delivery&10%Agst Successful Install",
    "value": "Y115",
    "description": "25%Adv,65%Agst Delivery&10%Agst Successful Install"
  },
  {
    "label": "50%Adv,40%after delivery&10%after compl.work",
    "value": "Y124",
    "description": "50%Adv,40%after delivery&10%after compl.work"
  },
  {
    "label": "10%Adv,80%RA Appr.eng.head,5%comp&5%aft.6M def.lia",
    "value": "Y125",
    "description": "10%Adv,80%RA Appr.eng.head,5%comp&5%aft.6M def.lia"
  },
  {
    "label": "10% advance against WO",
    "value": "Y126",
    "description": "10% advance against WO"
  },
  {
    "label": "Against RA bill duly approved by Site Eng.Head",
    "value": "Y127",
    "description": "Against RA bill duly approved by Site Eng.Head"
  },
  {
    "label": "completion of work",
    "value": "Y128",
    "description": "completion of work"
  },
  {
    "label": "after completion of 6 m defect liability period",
    "value": "Y129",
    "description": "after completion of 6 m defect liability period"
  },
  {
    "label": "30%Adv,60%Agst PI on appr.FAT,10%Aft comm.PBG 12M",
    "value": "Y130",
    "description": "30%Adv,60%Agst PI on appr.FAT,10%Aft comm.PBG 12M"
  },
  {
    "label": "After commissioning agst PBG valid for 12 mont",
    "value": "Y131",
    "description": "After commissioning agst PBG valid for 12 mont"
  },
  {
    "label": "30 DAYS AFTER DELIVERY ON SUCCESSFULTRIAL(NOT USE)",
    "value": "Y132",
    "description": "30 DAYS AFTER DELIVERY ON SUCCESSFULTRIAL(NOT USE)"
  },
  {
    "label": "25%Adv,65%Agst PI on appr.FAT,10%Aft comm.PBG 12M",
    "value": "Y133",
    "description": "25%Adv,65%Agst PI on appr.FAT,10%Aft comm.PBG 12M"
  },
  {
    "label": "90% ON RECPT OF MATERIAL&10% ON SUCCESSFUL INSTALL",
    "value": "Y134",
    "description": "90% ON RECPT OF MATERIAL&10% ON SUCCESSFUL INSTALL"
  },
  {
    "label": "20%Adv on PO accep.,70%on PI &10% PBG for 1 year",
    "value": "Y135",
    "description": "20%Adv on PO accep.,70%on PI &10% PBG for 1 year"
  },
  {
    "label": "PBG for 1 year",
    "value": "Y136",
    "description": "PBG for 1 year"
  },
  {
    "label": "30%Adv,20%Drawing Appr.,40%PI (FAT)&10%Succ.instal",
    "value": "Y137",
    "description": "30%Adv,20%Drawing Appr.,40%PI (FAT)&10%Succ.instal"
  },
  {
    "label": "30%Adv.with PO,50% on PI agst FAT, 20% after comm.",
    "value": "Y138",
    "description": "30%Adv.with PO,50% on PI agst FAT, 20% after comm."
  },
  {
    "label": "70% COD, 15%+GST on receipt & 15% after completion",
    "value": "Y139",
    "description": "70% COD, 15%+GST on receipt & 15% after completion"
  },
  {
    "label": "30% advance, 70% immediate after delivery",
    "value": "Y140",
    "description": "30% advance, 70% immediate after delivery"
  },
  {
    "label": "30% advance, 70% within 30 days of delivery",
    "value": "Y141",
    "description": "30% advance, 70% within 30 days of delivery"
  },
  {
    "label": "25% advance,50% agst PI & 25% aft.recpt of materia",
    "value": "Y142",
    "description": "25% advance,50% agst PI & 25% aft.recpt of materia"
  },
  {
    "label": "Quarterly Payment Agst Satisfactory Service Report",
    "value": "Y143",
    "description": "Quarterly Payment Agst Satisfactory Service Report"
  },
  {
    "label": "50% Advance & balance 50% after 90 days PDC",
    "value": "Y144",
    "description": "50% Advance & balance 50% after 90 days PDC"
  },
  {
    "label": "50% Advance & bal. 50% Within 45days from delivery",
    "value": "Y145",
    "description": "50% Advance & bal. 50% Within 45days from delivery"
  },
  {
    "label": "20%Adv on PO accep.,70%on PI &10% AGAISNT Instll.",
    "value": "Y146",
    "description": "20%Adv on PO accep.,70%on PI &10% AGAISNT Instll."
  },
  {
    "label": "80%Agst.Approved RA bill, 20%after instal.&commiss",
    "value": "Y147",
    "description": "80%Agst.Approved RA bill, 20%after instal.&commiss"
  },
  {
    "label": "30%onPO,Appd.drawing,60%Del.&10%aftercompl.validat",
    "value": "Y148",
    "description": "30%onPO,Appd.drawing,60%Del.&10%aftercompl.validat"
  },
  {
    "label": "70%Appd.RABill,30%aft.compl.validation&satisfactor",
    "value": "Y149",
    "description": "70%Appd.RABill,30%aft.compl.validation&satisfactor"
  },
  {
    "label": "Mob Adv5%Secu.Ch.65%apprdRA,25%Appr.Arch,5%1yrdefe",
    "value": "Y150",
    "description": "Mob Adv5%Secu.Ch.65%apprdRA,25%Appr.Arch,5%1yrdefe"
  },
  {
    "label": "5% aftr 1 yr defect",
    "value": "Y151",
    "description": "5% aftr 1 yr defect"
  },
  {
    "label": "40%Adv,50%agstPI(With GST),10%Aft.inst.validation",
    "value": "Y152",
    "description": "40%Adv,50%agstPI(With GST),10%Aft.inst.validation"
  },
  {
    "label": "100% AFTER FIRST PM VISIT AND CALLIBRATION",
    "value": "Y153",
    "description": "100% AFTER FIRST PM VISIT AND CALLIBRATION"
  },
  {
    "label": "Payment After Consumption",
    "value": "Y154",
    "description": "Payment After Consumption"
  },
  {
    "label": "75%Adv.withPO&25%After successful installation",
    "value": "Y155",
    "description": "75%Adv.withPO&25%After successful installation"
  },
  {
    "label": "75 days from the date of Inv.",
    "value": "Y156",
    "description": "75 days from the date of Inv."
  },
  {
    "label": "20%Adv.withPO,60%AgstPI,10%erection,10%commissioin",
    "value": "Y157",
    "description": "20%Adv.withPO,60%AgstPI,10%erection,10%commissioin"
  },
  {
    "label": "Within 6 Days",
    "value": "Y158",
    "description": "Within 6 Days"
  },
  {
    "label": "Within 3 Days",
    "value": "Y159",
    "description": "Within 3 Days"
  },
  {
    "label": "Within 4 Days",
    "value": "Y160",
    "description": "Within 4 Days"
  },
  {
    "label": "10%Mob.Adv,75%within7days,10%comp5%def.liability6M",
    "value": "Y162",
    "description": "10%Mob.Adv,75%within7days,10%comp5%def.liability6M"
  },
  {
    "label": "35%Adv,50%AfterDLV,15%Aftersuccessfulinstal&Comm.",
    "value": "Y163",
    "description": "35%Adv,50%AfterDLV,15%Aftersuccessfulinstal&Comm."
  },
  {
    "label": "40% advance via TT,60% Irrevocable LC,10% PBG",
    "value": "Y165",
    "description": "40% advance via TT,60% Irrevocable LC,10% PBG"
  },
  {
    "label": "80%after rept.material within Week&20%After instal",
    "value": "Y166",
    "description": "80%after rept.material within Week&20%After instal"
  },
  {
    "label": "25%Mob.Adv,50%within7day,20%comp,5%def.liability6M",
    "value": "Y167",
    "description": "25%Mob.Adv,50%within7day,20%comp,5%def.liability6M"
  },
  {
    "label": "10 Days After Delivery",
    "value": "Y168",
    "description": "10 Days After Delivery"
  },
  {
    "label": "70 Days from Invoice Date",
    "value": "Y171",
    "description": "70 Days from Invoice Date"
  },
  {
    "label": "80 Days from Invoice Date",
    "value": "Y172",
    "description": "80 Days from Invoice Date"
  },
  {
    "label": "35 days after delivery",
    "value": "Y173",
    "description": "35 days after delivery"
  },
  {
    "label": "25% advance and Bal. After 60 Days",
    "value": "Y174",
    "description": "25% advance and Bal. After 60 Days"
  },
  {
    "label": "50%Adv Agst order,50%after 6 month on sub of inv",
    "value": "Y179",
    "description": "50%Adv Agst order,50%after 6 month on sub of inv"
  },
  {
    "label": "180 days after delivery",
    "value": "Y180",
    "description": "180 days after delivery"
  },
  {
    "label": "240 days after delivery",
    "value": "Y181",
    "description": "240 days after delivery"
  },
  {
    "label": "30%Adv,70%after 45 days from recpt of Material",
    "value": "Y182",
    "description": "30%Adv,70%after 45 days from recpt of Material"
  },
  {
    "label": "27%Adv,73%after 45 days from rcpt of material",
    "value": "Y183",
    "description": "27%Adv,73%after 45 days from rcpt of material"
  },
  {
    "label": "50%Adv.agstorder,bal.before start rest 6months",
    "value": "Y184",
    "description": "50%Adv.agstorder,bal.before start rest 6months"
  },
  {
    "label": "20% ADV. WITH PO, BAL. 80% + GST AGAINST PI",
    "value": "Y185",
    "description": "20% ADV. WITH PO, BAL. 80% + GST AGAINST PI"
  },
  {
    "label": "100% advance with GST against Performa invoice",
    "value": "Y186",
    "description": "100% advance with GST against Performa invoice"
  },
  {
    "label": "100%Payment after sucss.ful instal.within 30 days",
    "value": "Y187",
    "description": "100%Payment after sucss.ful instal.within 30 days"
  },
  {
    "label": "70 days after delivery",
    "value": "Y188",
    "description": "70 days after delivery"
  },
  {
    "label": "100% Retention-30Days after delivery on succ.trail",
    "value": "Y189",
    "description": "100% Retention-30Days after delivery on succ.trail"
  },
  {
    "label": "20%Adv.agstPI,70%+GST After del.&10%aftersucc.inst",
    "value": "Y190",
    "description": "20%Adv.agstPI,70%+GST After del.&10%aftersucc.inst"
  },
  {
    "label": "100% Advance with GST",
    "value": "Y191",
    "description": "100% Advance with GST"
  },
  {
    "label": "15 Days PDC",
    "value": "Y192",
    "description": "15 Days PDC"
  },
  {
    "label": "30%Adv,60%Agst PI+GST & 10% after 30days agst SR",
    "value": "Y193",
    "description": "30%Adv,60%Agst PI+GST & 10% after 30days agst SR"
  },
  {
    "label": "After 30 days of delivery against SR",
    "value": "Y194",
    "description": "After 30 days of delivery against SR"
  },
  {
    "label": "30 DAYS ON RECEIPT OF SR",
    "value": "Y195",
    "description": "30 DAYS ON RECEIPT OF SR"
  },
  {
    "label": "90% ADV.& 10% AFTER 30 DAYS OF DELIVERY AGST SR",
    "value": "Y196",
    "description": "90% ADV.& 10% AFTER 30 DAYS OF DELIVERY AGST SR"
  }
]